import axios from "../../../../axios-order";
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import State from "../../../../asserts/jsonData/state.json";
import { toast } from "react-toastify";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Grid, Container, Stack, Typography, Box, styled, Stepper, Step, StepLabel, Button, Select, MenuItem, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { Paper } from "@material-ui/core";
import SelectInput from "../../../../components/ui/basicSelectInput";
import {
    DataGridPro,
} from '@mui/x-data-grid-pro';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import StepConnector from '@mui/material/StepConnector';
import { Check } from "@mui/icons-material";
import AssignmentIcon from '@mui/icons-material/Assignment';
import BallotIcon from '@mui/icons-material/Ballot';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import excelIconImage from '../../../../asserts/images/excelicon.svg'
import BoxWrapper from "../../../../components/ui/boxWrapper";

// Custom styled connector similar to your original design
const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#1976d2',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#1976d2',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#ccc',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

// Custom step icon component
const CustomStepIconRoot = styled('div')(({ theme }) => ({
    color: '#ccc',
    display: 'flex',
    height: 34,
    width: 34,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '500',
    borderRadius: '50%',
    backgroundColor: '#ccc',
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                backgroundColor: '#1976d2',
                color: '#fff',
                backgroundImage:
                    'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                backgroundColor: '#4caf50',
                color: '#fff',
            },
        },
    ],
}));

function CustomStepIcon(props) {
    const { active, completed, className, icon } = props;

    const icons = {
        1: <AssignmentIcon />,
        2: <BallotIcon />,
        3: <CalendarViewMonthIcon />,
    };

    return (
        <CustomStepIconRoot ownerState={{ active, completed }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                icons[String(props.icon)]
            )}
        </CustomStepIconRoot>
    );
}

// Custom SVG Icons
const CheckIcon = ({ size = 16, color = "#ffffff" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20,6 9,17 4,12"></polyline>
    </svg>
);

const ChevronRightIcon = ({ size = 20, color = "#2563eb" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9,18 15,12 9,6"></polyline>
    </svg>
);

// ---------- helpers ----------
const formatNatureOfPaymentLabel = (str) =>
    (str || '').toString().replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const getRowCodes = (row) => {
    if (Array.isArray(row?.available_codes) && row.available_codes.length > 0) {
        return row.available_codes.map((c) => c?.code).filter(Boolean);
    }
    return row?.code ? [row.code] : [];
};

// Correctly reads the real API shape: { records: [{ nature_of_payment: "..." }] }
const normalizeNatureOptions = (raw) => {
    if (!raw) return [];
    // API returns { records: [...] }
    const list = Array.isArray(raw.records) ? raw.records
               : Array.isArray(raw.data)    ? raw.data
               : Array.isArray(raw)         ? raw
               : [];
    return list
        .map((opt) => {
            if (typeof opt === 'string') return opt;
            if (opt && typeof opt === 'object') {
                return opt.nature_of_payment || opt.value || opt.code || opt.label || '';
            }
            return '';
        })
        .filter(Boolean);
};

const Form26QFiling = () => {
    const history = useHistory();
    const [activeStep, setActiveStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState(new Set());
    const [errors, setErrors] = useState({});

    const [activeFormStep, setActiveFormStep] = useState(0);
    const steps = ['Form 26Q Details', 'Challan Details', 'Annexure 1'];
    const [isExporting, setIsExporting] = useState(false);

    const [isFUVGenerating, setIsFUVGenerating] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [savedYesPan, setSavedYesPan] = useState('');
    const [savedYesDesignation, setSavedYesDesignation] = useState('');
    const [draftScreens, setDraftScreens] = useState({
        draft_screen_1: null,
        draft_screen_2: null,
        draft_screen_3: null,
    });
    const [previousData, setPreviousdata] = useState({});
    const [sameAddressFormData, setSameAddressFormData] = useState({
        responsible_pan: '',
        responsible_designation: '',
        same_as_prev_data: '',
    });

    const [challanData, setChallanData] = useState([]);
    const [annexureData, setAnnexureData] = useState([]);
    const [natureOfPaymentSelections, setNatureOfPaymentSelections] = useState({});
    const [isSavingSelections, setIsSavingSelections] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const [stateVisible, setStateVisible] = useState("edit");
    const [isEdit, setIsEdit] = useState(0);
    const [taxDeductorData, setTaxDeductorData] = useState({});
    const [fileName, setFileName] = useState("");
    const [CSIfile, setCSIfile] = useState();
    const [autoDownloadOpen, setAutoDownloadOpen] = useState(false);
    const [autoDownloadPhone, setAutoDownloadPhone] = useState('');
    const [isSendingOtp, setIsSendingOtp] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpValue, setOtpValue] = useState('');
    const [isSubmittingOtp, setIsSubmittingOtp] = useState(false);
    const [otpReferenceId, setOtpReferenceId] = useState('');
    const [autoDownloadBusinessEntityId, setAutoDownloadBusinessEntityId] = useState('');
    const [isDownloadingCSI, setIsDownloadingCSI] = useState(false);

    // const [natureOfPaymentSelections, setNatureOfPaymentSelections] = useState({});
    const [initialNatureOfPaymentSelections, setInitialNatureOfPaymentSelections] = useState({}); // NEW

    // NEW: tracks exactly which row keys the user has actually touched (via dropdown
    // or "Apply All), so Save only ever sends rows that were genuinely changed —
    // never every single-option row in the grid.
    const [changedRowKeys, setChangedRowKeys] = useState(new Set());

    // NEW: the value most recently picked from any row's dropdown (onChange).
    // The single common "Apply All" button (near Export) stays disabled until this
    // is set AND a grid filter is active. Cleared after every apply and after every
    // fresh data load, so it only ever fires after a real onChange event.
    const [pendingApplyValue, setPendingApplyValue] = useState('');

    // NEW: current DataGridPro filter model for the Annexure grid. Apply All only
    // works against the rows currently matching this filter.
    const [filterModel, setFilterModel] = useState({ items: [] });

    // NEW — selected code per row (_rowKey), only relevant for rows that have more
    // than one entry in available_codes. Rows with exactly one code auto-resolve to
    // that code and never need an entry here.
    const [codeSelections, setCodeSelections] = useState({});

    // NEW — nature-of-payment options fetched from get_nature_of_payment_options,
    // cached by `${repository_id}_${code}` so the same repository/code combination
    // is never requested twice.
    const [natureOfPaymentOptionsByCode, setNatureOfPaymentOptionsByCode] = useState({});

    // NEW — cache keys (`${repository_id}_${code}`) that currently have an in-flight
    // get_nature_of_payment_options request, so we never fire duplicate calls.
    const [loadingNatureOptionsKeys, setLoadingNatureOptionsKeys] = useState(new Set());

    const handleNext = () => {
        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep + 1);
    };

    const handleBack = () => {
        getForm26QData();
        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep - 1);
    };


    /*Form Details Info Started */
    const [employerDetailFormData, setEmployerDetailFormData] = useState({
        quarter: localStorage.getItem('quarter_26Q'),
        tan: '',
        last_tan: '',
        financial_year: localStorage.getItem('financial_year_26Q'),
        assessment_year: '',
        pan: '',
        type_of_deductor: '',
        is_revised_return: false,
        last_deductor_type: '',
        update_deductor_details: '',
        receipt_number_original: '',
        receipt_number_previous: '',
    });

    const [taxDeductionFormData, setTaxDeductionFormData] = useState({
        name: '',
        ministry_department_name: '',
        ministry_department_name_other: '',
        branch_division: '',
        state_name: null,
        ddo_code: '',
        pao_code: '',
        ddo_registration_number: '',
        pao_registration_number: '',
        flat_no: '',
        premises_name: '',
        road_or_street: '',
        area_or_location: '',
        town_or_city: '',
        pin_code: '',
        state: null,
        telephone_no: '',
        telephone_alternative: '',
        email: '',
        email_alternative: '',
        gstn: '',
        has_address_changed: false,
        ao_ain: '',
    });

    const [personFormData, setPersonFormData] = useState({
        responsible_name: '',
        responsible_pan: '',
        responsible_designation: '',
        responsible_flat_no: '',
        responsible_premises_name: '',
        responsible_road_or_street: '',
        responsible_area_or_location: '',
        responsible_town_or_city: '',
        responsible_pin_code: '',
        responsible_state: null,
        responsible_telephone_no: '',
        responsible_telephone_alternative: '',
        responsible_mobile_no: '',
        responsible_email: '',
        responsible_email_alternative: '',
        responsible_address_same: true,
        responsible_address_changed: false,
        responsible_receipt_number: '',
        filed_earlier_period: false,
        previous_statement_number: ''
    });

    useEffect(() => {
            getForm26QData();
    }, []);


    useEffect(() => {
        ValidatorForm.addValidationRule('isPANDifferent', (value) => {
            if (value && employerDetailFormData.pan) {
                return value.toUpperCase() !== employerDetailFormData.pan.toUpperCase();
            }
            return true;
        });

        return () => {
            ValidatorForm.removeValidationRule('isPANDifferent');
        };
    }, [employerDetailFormData.pan]);

useEffect(() => {
    if (activeStep === 2) {
        if (personFormData.responsible_address_same === true) {
                let YesPan = sameAddressFormData.responsible_pan;
                let YesDesignation = sameAddressFormData.responsible_designation;
                if (sameAddressFormData.same_as_prev_data === 'No') {
                    YesPan = '';
                    YesDesignation = '';
                }

            setPersonFormData(prev => ({
                ...prev,
                    responsible_name: prev.responsible_name || taxDeductionFormData.name,
                    responsible_flat_no: prev.responsible_flat_no || taxDeductionFormData.flat_no,
                    responsible_premises_name: prev.responsible_premises_name || taxDeductionFormData.premises_name,
                    responsible_road_or_street: prev.responsible_road_or_street || taxDeductionFormData.road_or_street,
                    responsible_area_or_location: prev.responsible_area_or_location || taxDeductionFormData.area_or_location,
                    responsible_town_or_city: prev.responsible_town_or_city || taxDeductionFormData.town_or_city,
                    responsible_pin_code: prev.responsible_pin_code || taxDeductionFormData.pin_code,
                    responsible_state: prev.responsible_state || taxDeductionFormData.state,
                    responsible_telephone_no: prev.responsible_telephone_no || taxDeductionFormData.telephone_no,
                    responsible_telephone_alternative: prev.responsible_telephone_alternative || taxDeductionFormData.telephone_alternative,
                    responsible_email: prev.responsible_email || taxDeductionFormData.email,
                    responsible_email_alternative: prev.responsible_email_alternative || taxDeductionFormData.email_alternative,
                    responsible_pan: YesPan,
                    responsible_designation: YesDesignation,
            }));
        } else {
            const responsiblePan = taxDeductorData.particulars_person_responsible_for_deduction?.pan || '';
            if (responsiblePan && !personFormData.responsible_pan) {
                setPersonFormData(prev => ({
                    ...prev,
                    responsible_pan: responsiblePan
                }));
            }
        }
    }
    }, [activeStep, taxDeductionFormData, personFormData.responsible_address_same]);

    const getChallanDetails = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q')
        }
        axios.post('/get_tds_challan_details_for_rpu_file', payload)
            .then((res) => {
                console.log("Challan Response ==>" + JSON.stringify(res));
                setChallanData(res.data.records);
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            }
            );
    }

    const getAnnexureDetails = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q')
        }
        axios.post('/get_tds_challan_details_for_annexure1', payload)
            .then((res) => {
                console.log("Annexure Response ==>" + JSON.stringify(res));
                setAnnexureData(res.data.records);
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            }
            );
    }
const getTds26QRpuAnnexureData = () => {
    const payload = {
        business_entity_id: localStorage.getItem('business_entity_id'),
        financial_year: localStorage.getItem('financial_year_26Q'),
        quarter: localStorage.getItem('quarter_26Q')
    };

    axios.post('/get_tds_26q_rpu_annexure_data', payload)
        .then((res) => {
            console.log("RPU & Annexure Response ==> ", JSON.stringify(res));

            const mappedAnnexureData = (res.data.annexure1_data || []).map((row, index) => ({
                ...row,
                _rowKey: `${row.id}-${index}`
            }));

            setChallanData(res?.data?.rpu_data || []);
            setAnnexureData(mappedAnnexureData);

            const initialSelections = {};
            const initialCodeSelections = {};
            const uniqueSingleCodeCombos = new Set();

            mappedAnnexureData.forEach((row) => {
                const codes = getRowCodes(row);

                // Bind the already saved nature of payment from API
                if (row.nature_of_payment_select) {
                    initialSelections[row._rowKey] = {
                        id: row.id,
                        nature_of_payment: row.nature_of_payment_select,
                    };
                }

                // Auto-select code when only one is available
                if (codes.length === 1) {
                    initialCodeSelections[row._rowKey] = codes[0];
                    uniqueSingleCodeCombos.add(`${row.repository_id}::${codes[0]}`);
                }
            });

            setNatureOfPaymentSelections(initialSelections);
            setInitialNatureOfPaymentSelections(initialSelections);
            setCodeSelections(initialCodeSelections);
            setNatureOfPaymentOptionsByCode({});
            setChangedRowKeys(new Set());
            setPendingApplyValue('');
            setFilterModel({ items: [] });

            // Pre-fetch nature options for all single-code rows.
            // force = true  -> ignore the stale cache captured in this closure
            // rows = fresh  -> auto-fill works against the newly loaded rows
            uniqueSingleCodeCombos.forEach((combo) => {
                const [repoIdStr, code] = combo.split('::');
                const repoId = Number(repoIdStr);
                fetchNatureOfPaymentOptionsForCode(
                    Number.isNaN(repoId) ? repoIdStr : repoId,
                    code,
                    true,
                    mappedAnnexureData
                );
            });
        })
        .catch((err) => {
            console.error("Error fetching data:", err);
        });
};



    const getForm26QData = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q')
        };
        axios.post(`/get_form_26q`, payload)
            .then((res) => {
                if (res.data.status === true) {
                    checkFilingStatus();
                    setIsEdit(res.data.data.id);
                    localStorage.setItem('form26q_id', res.data.data.id);

                    // Set draft screen values
                    setDraftScreens({
                        draft_screen_1: res.data.data.draft_screen_1,
                        draft_screen_2: res.data.data.draft_screen_2,
                        draft_screen_3: res.data.data.draft_screen_3,
                    });
                    setPreviousdata(res.data.data.same_as_prev_data);

                    let deductorType = '';
                    if (res.data.data.pan) {
                        const fourthChar2 = res.data.data.pan.charAt(3);
                        if (fourthChar2 === 'C') deductorType = "Company";
                        else if (fourthChar2 === 'B') deductorType = "Body of Individuals";
                        else if (fourthChar2 === 'F') deductorType = "Firm";
                        else if (fourthChar2 === 'P' || fourthChar2 === 'H') deductorType = "Individual/HUF";
                        }

                    const assessmentYear = calculateAssessmentYearFull(res.data.data.financial_year);

                    setEmployerDetailFormData(prevFormData => ({
                        ...prevFormData,
                        quarter: localStorage.getItem('quarter_26Q'),
                        tan: res.data.data.tan || '',
                        last_tan: res.data.data.last_tan || '',
                        financial_year: res.data.data.financial_year || localStorage.getItem('financial_year_26Q'),
                        assessment_year: res.data.data.assessment_year || assessmentYear,
                        pan: res.data.data.pan || '',
                        type_of_deductor: res.data.data.type_of_deductor || deductorType,
                        is_revised_return: res.data.data.is_revised_return || false,
                        last_deductor_type: res.data.data.last_deductor_type || '',
                        update_deductor_details: res.data.data.update_deductor_details || '',
                        receipt_number_original: res.data.data.receipt_number_original || '',
                        receipt_number_previous: res.data.data.receipt_number_previous || '',
                    }));

                    setTaxDeductionFormData(prevFormData => ({
                        ...prevFormData,
                        name: res.data.data.name || '',
                        ministry_department_name: res.data.data.ministry_department_name || '',
                        ministry_department_name_other: res.data.data.ministry_department_name_other || '',
                        branch_division: res.data.data.branch_division || '',
                        state_name: res.data.data.state_name || '',
                        ddo_code: res.data.data.ddo_code || '',
                        pao_code: res.data.data.pao_code || '',
                        ddo_registration_number: res.data.data.ddo_registration_number || '',
                        pao_registration_number: res.data.data.pao_registration_number || '',
                        flat_no: res.data.data.flat_no || '',
                        premises_name: res.data.data.premises_name || '',
                        road_or_street: res.data.data.road_or_street || '',
                        area_or_location: res.data.data.area_or_location || '',
                        town_or_city: res.data.data.town_or_city || '',
                        pin_code: res.data.data.pin_code || '',
                        state: res.data.data.state || '',
                        telephone_no: res.data.data.telephone_no || '',
                        telephone_alternative: res.data.data.telephone_alternative || '',
                        email: res.data.data.email || '',
                        email_alternative: res.data.data.email_alternative || '',
                        // gstn: res.data.data.gstn || '',
                        gstn: res.data.data.gstn || localStorage.getItem('gst') || '',
                        has_address_changed: res.data.data.has_address_changed || false,
                        ao_ain: res.data.data.ao_ain || '',
                    }));

                    setPersonFormData(prevFormData => ({
                        ...prevFormData,
                        responsible_name: res.data.data.responsible_name || '',
                        responsible_pan: res.data.data.responsible_pan || '',
                        responsible_designation: res.data.data.responsible_designation || '',
                        responsible_flat_no: res.data.data.responsible_flat_no || '',
                        responsible_premises_name: res.data.data.responsible_premises_name || '',
                        responsible_road_or_street: res.data.data.responsible_road_or_street || '',
                        responsible_area_or_location: res.data.data.responsible_area_or_location || '',
                        responsible_town_or_city: res.data.data.responsible_town_or_city || '',
                        responsible_pin_code: res.data.data.responsible_pin_code || '',
                        responsible_state: res.data.data.responsible_state || '',
                        responsible_telephone_no: res.data.data.responsible_telephone_no || '',
                        responsible_telephone_alternative: res.data.data.responsible_telephone_alternative || '',
                        responsible_mobile_no: res.data.data.responsible_mobile_no || '',
                        responsible_email: res.data.data.responsible_email || '',
                        responsible_email_alternative: res.data.data.responsible_email_alternative || '',
                        responsible_address_same: res.data.data.responsible_address_same !== undefined
                            ? res.data.data.responsible_address_same : true,
                        responsible_address_changed: res.data.data.responsible_address_changed || false,
                        responsible_receipt_number: res.data.data.responsible_receipt_number || false,
                        filed_earlier_period: res.data.data.filed_earlier_period || false,
                        previous_statement_number: res.data.data.previous_statement_number || '',
                    }));

                    // ✅ Initialize YES cache — same as 24Q
                    setSavedYesPan(res.data.data.responsible_pan || '');
                    setSavedYesDesignation(res.data.data.responsible_designation || '');

                    setSameAddressFormData({
                        responsible_pan: res.data.data.responsible_pan || '',
                        responsible_designation: res.data.data.responsible_designation || '',
                        same_as_prev_data: res.data.data.same_as_prev_data || '',
                    });

                    setFileName(res.data.data.csi_file_name || '');

                    // ✅ FIX: Store the file data with proper prefix for consistency
                    if (res.data.data.csi_file_data) {
                        // If the data doesn't have the prefix, add it
                        const fileData = res.data.data.csi_file_data.startsWith('data:')
                            ? res.data.data.csi_file_data
                            : `data:application/octet-stream;base64,${res.data.data.csi_file_data}`;
                        setCSIfile(fileData);
                    } else {
                        setCSIfile('');
                    }
                } else {
                    getBusinessEntityDetails().then((deductorData) => {
                        if (deductorData) updateTaxDeductorData(deductorData);
                    });
                }
            })
            .catch((err) => {
                console.error("Error fetching form 26Q data:", err);
            });
    };



    const checkFilingStatus = () => {
        axios.get(`/get_filing_logs_26q/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                const currentRecord = res?.data?.records?.find(
                    record =>
                        record.financial_year === localStorage.getItem('financial_year_26Q') &&
                        record.quarter === localStorage.getItem('quarter_26Q') &&
                        record.status.toLowerCase() === 'succeeded'
                );
                if (currentRecord) setIsViewOnly(true);
            })
            .catch((err) => console.error("Error checking filing status:", err));
    };


    // const getForm26QData = () => {
    //     const payload = {
    //         business_entity_id: localStorage.getItem('business_entity_id'),
    //         financial_year: localStorage.getItem('financial_year_26Q'),
    //         quarter: localStorage.getItem('quarter_26Q')
    //     }
    //     axios.post(`/get_form_26q`, payload)
    //         .then((res) => {
    //             console.log("Response ==>" + JSON.stringify(res));
    //             console.log("Status ==>" + res.data.status);
    //             if (res.data.status === true) {
    //                 console.log("Comes here for Data");
    //                 setIsEdit(res.data.data.id);
    //                 let deductorType = ''
    //                 if (res.data.data.pan) {
    //                     const fourthChar2 = res.data.data.pan.charAt(3);
    //                     if (fourthChar2 === 'C') {
    //                         deductorType = "Company";
    //                     } else if (fourthChar2 === 'B') {
    //                         deductorType = "Body of Individuals";
    //                     } else if (fourthChar2 === 'F') {
    //                         deductorType = "Firm";
    //                     } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
    //                         deductorType = "Individual/HUF";
    //                     }
    //                 }
    //                 // Update formData with tan, pan, and csi_file_name from response
    //                 setEmployerDetailFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     quarter: localStorage.getItem('quarter_26Q'),
    //                     tan: res.data.data.tan || '',
    //                     last_tan: res.data.data.last_tan || '',
    //                     financial_year: res.data.data.financial_year || localStorage.getItem('financial_year_26Q'),
    //                     assessment_year: res.data.data.assessment_year || '',
    //                     pan: res.data.data.pan || '',
    //                     type_of_deductor: res.data.data.type_of_deductor || deductorType,
    //                     is_revised_return: res.data.data.is_revised_return || false,
    //                     last_deductor_type: res.data.data.last_deductor_type || '',
    //                     update_deductor_details: res.data.data.update_deductor_details || '',
    //                     receipt_number_original: res.data.data.receipt_number_original || '',
    //                     receipt_number_previous: res.data.data.receipt_number_previous || '',
    //                 }));

    //                 setTaxDeductionFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     name: res.data.data.name || '',
    //                     ministry_department_name: res.data.data.ministry_department_name || '',
    //                     ministry_department_name_other: res.data.data.ministry_department_name_other || '',
    //                     branch_division: res.data.data.branch_division || '',
    //                     state_name: res.data.data.state_name || '',
    //                     ddo_code: res.data.data.ddo_code || '',
    //                     pao_code: res.data.data.pao_code || '',
    //                     ddo_registration_number: res.data.data.ddo_registration_number || '',
    //                     pao_registration_number: res.data.data.pao_registration_number || '',
    //                     flat_no: res.data.data.flat_no || '',
    //                     premises_name: res.data.data.premises_name || '',
    //                     road_or_street: res.data.data.road_or_street || '',
    //                     area_or_location: res.data.data.area_or_location || '',
    //                     town_or_city: res.data.data.town_or_city || '',
    //                     pin_code: res.data.data.pin_code || '',
    //                     state: res.data.data.state || '',
    //                     telephone_no: res.data.data.telephone_no || '',
    //                     telephone_alternative: res.data.data.telephone_alternative || '',
    //                     email: res.data.data.email || '',
    //                     email_alternative: res.data.data.email_alternative || '',
    //                     gstn: res.data.data.gstn || '',
    //                     has_address_changed: res.data.data.has_address_changed || false,
    //                     ao_ain: res.data.data.ao_ain || ''
    //                 }));

    //                 setPersonFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     responsible_name: res.data.data.responsible_name || '',
    //                     responsible_pan: res.data.data.responsible_pan || '',
    //                     responsible_designation: res.data.data.responsible_designation || '',
    //                     responsible_flat_no: res.data.data.responsible_flat_no || '',
    //                     responsible_premises_name: res.data.data.responsible_premises_name || '',
    //                     responsible_road_or_street: res.data.data.responsible_road_or_street || '',
    //                     responsible_area_or_location: res.data.data.responsible_area_or_location || '',
    //                     responsible_town_or_city: res.data.data.responsible_town_or_city || '',
    //                     responsible_pin_code: res.data.data.responsible_pin_code || '',
    //                     responsible_state: res.data.data.responsible_state || '',
    //                     responsible_telephone_no: res.data.data.responsible_telephone_no || '',
    //                     responsible_telephone_alternative: res.data.data.responsible_telephone_alternative || '',
    //                     responsible_mobile_no: res.data.data.responsible_mobile_no || '',
    //                     responsible_email: res.data.data.responsible_email || '',
    //                     responsible_email_alternative: res.data.data.responsible_email_alternative || '',
    //                     responsible_address_same: res.data.data.responsible_address_same || true,
    //                     responsible_address_changed: res.data.data.responsible_address_changed || false,
    //                     responsible_receipt_number: res.data.data.responsible_receipt_number || false,
    //                     filed_earlier_period: res.data.data.filed_earlier_period || false,
    //                 }));

    //                 // Set the csi_file_name from the API response
    //                 setFileName(res.data.data.csi_file_name || '');
    //                 setCSIfile(res.data.data.csi_file_data || '');
    //             } else {
    //                 console.log("Comes here for no data")
    //                 updateTaxDeductorData(taxDeductorData);
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Error fetching business entity details:", err);
    //         })
    // }

    // const getForm26QData = () => {
    //     const payload = {
    //         business_entity_id: localStorage.getItem('business_entity_id'),
    //         financial_year: localStorage.getItem('financial_year_26Q'),
    //         quarter: localStorage.getItem('quarter_26Q')
    //     }
    //     axios.post(`/get_form_26q`, payload)
    //         .then((res) => {
    //             console.log("Response ==>" + JSON.stringify(res));
    //             console.log("Status ==>" + res.data.status);
    //             if (res.data.status === true) {
    //                 console.log("Comes here for Data");
    //                 setIsEdit(res.data.data.id);
    //                 let deductorType = ''
    //                 if (res.data.data.pan) {
    //                     const fourthChar2 = res.data.data.pan.charAt(3);
    //                     if (fourthChar2 === 'C') {
    //                         deductorType = "Company";
    //                     } else if (fourthChar2 === 'B') {
    //                         deductorType = "Body of Individuals";
    //                     } else if (fourthChar2 === 'F') {
    //                         deductorType = "Firm";
    //                     } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
    //                         deductorType = "Individual/HUF";
    //                     }
    //                 }
    //                 //Update formData with tan and pan from response
    //                 setEmployerDetailFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     quarter: localStorage.getItem('quarter_26Q'),
    //                     tan: res.data.data.tan || '',
    //                     last_tan: res.data.data.last_tan || '',
    //                     financial_year: res.data.data.financial_year || localStorage.getItem('financial_year_26Q'),
    //                     assessment_year: res.data.data.assessment_year || '',
    //                     pan: res.data.data.pan || '',
    //                     type_of_deductor: res.data.data.type_of_deductor || deductorType,
    //                     is_revised_return: res.data.data.is_revised_return || false,
    //                     last_deductor_type: res.data.data.last_deductor_type || '',
    //                     update_deductor_details: res.data.data.update_deductor_details || '',
    //                     receipt_number_original: res.data.data.receipt_number_original || '',
    //                     receipt_number_previous: res.data.data.receipt_number_previous || '',
    //                 }));

    //                 setTaxDeductionFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     name: res.data.data.name || '',
    //                     ministry_department_name: res.data.data.ministry_department_name || '',
    //                     ministry_department_name_other: res.data.data.ministry_department_name_other || '',
    //                     branch_division: res.data.data.branch_division || '',
    //                     state_name: res.data.data.state_name || '',
    //                     ddo_code: res.data.data.ddo_code || '',
    //                     pao_code: res.data.data.pao_code || '',
    //                     ddo_registration_number: res.data.data.ddo_registration_number || '',
    //                     pao_registration_number: res.data.data.pao_registration_number || '',
    //                     flat_no: res.data.data.flat_no || '',
    //                     premises_name: res.data.data.premises_name || '',
    //                     road_or_street: res.data.data.road_or_street || '',
    //                     area_or_location: res.data.data.area_or_location || '',
    //                     town_or_city: res.data.data.town_or_city || '',
    //                     pin_code: res.data.data.pin_code || '',
    //                     state: res.data.data.state || '',
    //                     telephone_no: res.data.data.telephone_no || '',
    //                     telephone_alternative: res.data.data.telephone_alternative || '',
    //                     email: res.data.data.email || '',
    //                     email_alternative: res.data.data.email_alternative || '',
    //                     gstn: res.data.data.gstn || '',
    //                     has_address_changed: res.data.data.has_address_changed || false,
    //                     ao_ain: res.data.data.ao_ain || ''
    //                 }));

    //                 setPersonFormData(prevFormData => ({
    //                     ...prevFormData,
    //                     responsible_name: res.data.data.responsible_name || '',
    //                     responsible_pan: res.data.data.responsible_pan || '',
    //                     responsible_designation: res.data.data.responsible_designation || '',
    //                     responsible_flat_no: res.data.data.responsible_flat_no || '',
    //                     responsible_premises_name: res.data.data.responsible_premises_name || '',
    //                     responsible_road_or_street: res.data.data.responsible_road_or_street || '',
    //                     responsible_area_or_location: res.data.data.responsible_area_or_location || '',
    //                     responsible_town_or_city: res.data.data.responsible_town_or_city || '',
    //                     responsible_pin_code: res.data.data.responsible_pin_code || '',
    //                     responsible_state: res.data.data.responsible_state || '',
    //                     responsible_telephone_no: res.data.data.responsible_telephone_no || '',
    //                     responsible_telephone_alternative: res.data.data.responsible_telephone_alternative || '',
    //                     responsible_mobile_no: res.data.data.responsible_mobile_no || '',
    //                     responsible_email: res.data.data.responsible_email || '',
    //                     responsible_email_alternative: res.data.data.responsible_email_alternative || '',
    //                     responsible_address_same: res.data.data.responsible_address_same || true,
    //                     responsible_address_changed: res.data.data.responsible_address_changed || false,
    //                     responsible_receipt_number: res.data.data.responsible_receipt_number || false,
    //                     filed_earlier_period: res.data.data.filed_earlier_period || false,
    //                 }));
    //             } else {
    //                 console.log("Comes here for no data")
    //                 updateTaxDeductorData(taxDeductorData);
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Error fetching business entity details:", err);
    //         })
    // }

    const updateTaxDeductorData = (deductorData) => {
        let deductorType = ''
        console.log("JSON ==>" + JSON.stringify(deductorData));
        if (deductorData.particulars_of_statement.pan) {
            const fourthChar2 = deductorData.particulars_of_statement.pan.charAt(3);
            if (fourthChar2 === 'C') {
                deductorType = "Company";
            } else if (fourthChar2 === 'B') {
                deductorType = "Body of Individuals";
            } else if (fourthChar2 === 'F') {
                deductorType = "Firm";
            } else if (fourthChar2 === 'P' || fourthChar2 === 'H') {
                deductorType = "Individual/HUF";
            }
        }
        // Update formData with tan and pan from response
        setEmployerDetailFormData(prevFormData => ({
            ...prevFormData,
            quarter: localStorage.getItem('quarter_26Q'),
            tan: deductorData.particulars_of_statement.tan || '',
            financial_year: localStorage.getItem('financial_year_26Q'),
            assessment_year: calculateAssessmentYearFull(localStorage.getItem('financial_year_26Q')),
            pan: deductorData.particulars_of_statement.pan || '',
            type_of_deductor: deductorData.particulars_of_statement.type_of_deductor || deductorType,
        }));

        setTaxDeductionFormData(prevFormData => ({
            ...prevFormData,
            name: deductorData.particulars_of_deductor.name || '',
            email: deductorData.particulars_of_deductor.email || '',
            telephone_no: deductorData.particulars_of_deductor.contact_number || '',
            flat_no: deductorData.particulars_of_deductor.flat_no || '',
            premises_name: deductorData.particulars_of_deductor.premises_name || '',
            road_or_street: deductorData.particulars_of_deductor.road_street_name || '',
            area_or_location: deductorData.particulars_of_deductor.area || '',
            town_or_city: deductorData.particulars_of_deductor.city || '',
            pin_code: deductorData.particulars_of_deductor.pincode || '',
            state: deductorData.particulars_of_deductor.state?.toUpperCase() || '',
            // gstn: deductorData.particulars_of_deductor.gst || '',
            gstn: localStorage.getItem('gst') || '',
        }));

        setPersonFormData(prevFormData => ({
            ...prevFormData,
            responsible_name: deductorData.particulars_person_responsible_for_deduction.name || '',
            responsible_pan: deductorData.particulars_person_responsible_for_deduction.pan || '',
            responsible_flat_no: deductorData.particulars_person_responsible_for_deduction.flat_no || '',
            responsible_premises_name: deductorData.particulars_person_responsible_for_deduction.premises_name || '',
            responsible_road_or_street: deductorData.particulars_person_responsible_for_deduction.road_or_street || '',
            responsible_area_or_location: deductorData.particulars_person_responsible_for_deduction.area_or_location || '',
            responsible_town_or_city: deductorData.particulars_person_responsible_for_deduction.town_or_city || '',
            responsible_pin_code: deductorData.particulars_person_responsible_for_deduction.pin_code || '',
            responsible_state: (deductorData.particulars_person_responsible_for_deduction.state),
            responsible_telephone_no: deductorData.particulars_person_responsible_for_deduction.telephone_primary || '',
            responsible_telephone_alternative: deductorData.particulars_person_responsible_for_deduction.telephone_alternative || '',
            responsible_mobile_no: deductorData.particulars_person_responsible_for_deduction.mobile_no || '',
            responsible_email: deductorData.particulars_person_responsible_for_deduction.email || '',
            responsible_email_alternative: deductorData.particulars_person_responsible_for_deduction.email_alternative || '',
        }));
    }

    const getBusinessEntityDetails = () => {
        return axios.get(`/get_form26q_initial_form_data/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                if (res?.data?.status) {
                    if (res?.data?.message) {
                        // toast.warning(res?.data?.message || '', {
                        //     autoClose: 3000,
                        //     progress: 0,
                        // });
                    }
                    setTaxDeductorData(res.data.data);
                    updateTaxDeductorData(res.data.data);
                    return res.data.data;
                }
            })
            .catch((err) => {
                console.error("Error fetching business entity details:", err);
            })
    }

    const validateTypeOfDeductor = () => {
        if (!employerDetailFormData.type_of_deductor || employerDetailFormData.type_of_deductor.trim() === '') {
            setErrors(prev => ({
                ...prev,
                type_of_deductor: 'Type of Deductor is required'
            }));
            return false;
        }
        return true;
    };

    const handleChange = (e) => {
        if (e) {
            const { name, value } = e.target;
            if (name === 'pan') {
                const fourthChar2 = value.charAt(3);
                console.log("Pan Char at 4 ==>" + fourthChar2 + " and visibility of State ==>" + stateVisible);
                if (fourthChar2 === 'C' || fourthChar2 === 'B' || fourthChar2 === 'F' || fourthChar2 === 'P') {
                    setStateVisible("edit");
                } else {
                    setStateVisible("view");
                }
                console.log("Pan Char at 4 ==>" + fourthChar2 + " and visibility of State ==>" + stateVisible);
            }

            if (name === 'financial_year') {
                const assessmentYear = calculateAssessmentYearFull(value);
                setEmployerDetailFormData({
                    ...employerDetailFormData,
                    [name]: value,
                    assessment_year: assessmentYear
                });
            } else if (name === "is_revised_return") {
                const val = value === 1 ? true : false;
                setEmployerDetailFormData({
                    ...employerDetailFormData,
                    is_revised_return: val
                });
            } else {
                setEmployerDetailFormData({ ...employerDetailFormData, [name]: value });
            }
            // Clear error when user starts typing
            if (errors[name]) {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    }

    const calculateAssessmentYearFull = (financialYear) => {
        const startYear = parseInt(financialYear.split('-')[0]);
        const assessmentStartYear = startYear + 1;
        const assessmentEndYear = startYear + 2;

        return `${assessmentStartYear}-${assessmentEndYear}`;
    }

    const handleEmployerChange = (e) => {
        if (e) {
            const { name, value } = e.target;

            if (name === "has_address_changed") {
                const val = value === 1 ? true : false;
                setTaxDeductionFormData({
                    ...employerDetailFormData,
                    has_address_changed: val,
                });

            } else {
                setTaxDeductionFormData({ ...taxDeductionFormData, [name]: value });
            }

            // Clear error when user starts typing
            if (errors[name]) {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    }

    const handleDeductorChange = (e) => {
        if (e) {
            const { name, value } = e.target;

            if (name === "responsible_address_same") {
                if (value === 2) { // When "No" is selected

                    setSavedYesPan(personFormData.responsible_pan || '');
                    setSavedYesDesignation(personFormData.responsible_designation || '');

                    const responsiblePersonData = taxDeductorData.particulars_person_responsible_for_deduction;
                    const isResponsiblePersonEmpty = !responsiblePersonData || Object.keys(responsiblePersonData).length === 0;

                    if (isResponsiblePersonEmpty) {
                        toast.warning('Please add the deduction person data in business entity details', {
                            autoClose: 3000,
                            progress: 0,
                        });

                        // Clear all fields when no data exists
                        setPersonFormData({
                            ...personFormData,
                            responsible_name: '',
                            responsible_pan: '',
                            responsible_flat_no: '',
                            responsible_premises_name: '',
                            responsible_road_or_street: '',
                            responsible_area_or_location: '',
                            responsible_town_or_city: '',
                            responsible_pin_code: '',
                            responsible_state: null,
                            responsible_telephone_no: '',
                            responsible_telephone_alternative: '',
                            responsible_email: '',
                            responsible_email_alternative: '',
                            responsible_mobile_no: '',
                            responsible_designation: '',
                            responsible_address_same: false
                        });
                    } else {
                        // Populate with business entity data when it exists
                        setPersonFormData({
                            ...personFormData,
                            responsible_name: responsiblePersonData.name || '',
                            responsible_pan: responsiblePersonData.pan || '',
                            responsible_flat_no: responsiblePersonData.flat_no || '',
                            responsible_premises_name: responsiblePersonData.premises_name || '',
                            responsible_road_or_street: responsiblePersonData.road_or_street || '',
                            responsible_area_or_location: responsiblePersonData.area_or_location || '',
                            responsible_town_or_city: responsiblePersonData.town_or_city || '',
                            responsible_pin_code: responsiblePersonData.pin_code || '',
                            responsible_state: responsiblePersonData.state || null,
                            responsible_telephone_no: responsiblePersonData.telephone_primary || '',
                            responsible_telephone_alternative: responsiblePersonData.telephone_alternative || '',
                            responsible_email: responsiblePersonData.email || '',
                            responsible_email_alternative: responsiblePersonData.email_alternative || '',
                            responsible_mobile_no: responsiblePersonData.mobile_no || '',
                            responsible_designation: responsiblePersonData.designation || '',
                            responsible_address_same: false
                        });
                    }
                } else { // When "Yes" is selected

                    let YesPan = sameAddressFormData.responsible_pan;
                    let YesDesignation = sameAddressFormData.responsible_designation;
                    if (sameAddressFormData.same_as_prev_data === 'No') {
                        YesPan = '';
                        YesDesignation = '';
                    }
                    if (savedYesPan) YesPan = savedYesPan;
                    if (savedYesDesignation) YesDesignation = savedYesDesignation;

                    // Populate with tax deduction form data
                setPersonFormData({
                    ...personFormData,
                        responsible_name: taxDeductionFormData.name || '',
                        responsible_pan: YesPan,
                        responsible_flat_no: taxDeductionFormData.flat_no || '',
                        responsible_premises_name: taxDeductionFormData.premises_name || '',
                        responsible_road_or_street: taxDeductionFormData.road_or_street || '',
                        responsible_area_or_location: taxDeductionFormData.area_or_location || '',
                        responsible_town_or_city: taxDeductionFormData.town_or_city || '',
                        responsible_pin_code: taxDeductionFormData.pin_code || '',
                        responsible_state: taxDeductionFormData.state || null,
                        responsible_telephone_no: taxDeductionFormData.telephone_no || '',
                        responsible_telephone_alternative: taxDeductionFormData.telephone_alternative || '',
                        responsible_email: taxDeductionFormData.email || '',
                        responsible_email_alternative: taxDeductionFormData.email_alternative || '',
                        responsible_mobile_no: '',
                        responsible_designation: YesDesignation,
                        responsible_address_same: true
                    });

                    // Clear PAN error if it exists when "Yes" is selected
                    if (errors.responsible_pan) {
                    setErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors.responsible_pan;
                        return newErrors;
                    });
                }
                }
            } else if (name === "responsible_address_changed" || name === "responsible_receipt_number" || name === "filed_earlier_period") {
                const val = value === 1 ? true : false;
                setPersonFormData({
                    ...personFormData,
                    [name]: val
                });
            } else {
                setPersonFormData({ ...personFormData, [name]: value });

                if (personFormData.responsible_address_same === true) {
                    if (name === "responsible_pan") {
                        setSavedYesPan(value);
                    }
                    if (name === "responsible_designation") {
                        setSavedYesDesignation(value);
                    }
                }

                // Add validation for responsible_pan to check if it matches employerDetailFormData.pan
                if (name === "responsible_pan" && value && employerDetailFormData.pan) {
                    if (value.toUpperCase() === employerDetailFormData.pan.toUpperCase()) {
                        setErrors(prev => ({
                            ...prev,
                            responsible_pan: 'Responsible person PAN cannot be same as Deductor PAN'
                        }));
                    } else {
                        // Clear the error if PANs are different
                        setErrors(prev => {
                            const newErrors = { ...prev };
                            delete newErrors.responsible_pan;
                            return newErrors;
                        });
                    }
                }
            }

            // Clear error when user starts typing
            if (errors[name] && name !== "responsible_pan") {
                setErrors(prev => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
    }

    const handleFormDetailsBack = () => {
        console.log("Active Step ==>" + activeStep);
        if (activeStep == 0) {
            history.goBack()
            return
        }
        setActiveStep(Math.max(0, activeStep - 1));
    };

    const handleFormDetailSubmit = async () => {
        if (activeStep === 0) {
            if (!validateTypeOfDeductor()) {
                toast.error('Please fill all required fields', { autoClose: 3000, progress: 0 });
                return;
            }

            const currentAssessmentYear = calculateAssessmentYearFull(employerDetailFormData.financial_year);
            const payload = {
                ...employerDetailFormData,
                assessment_year: currentAssessmentYear,
                ...taxDeductionFormData,
                ...personFormData,
                business_entity_id: localStorage.getItem('business_entity_id'),
                csi_file_data: CSIfile,
                csi_file_name: fileName,
                same_as_prev_data: (draftScreens.draft_screen_1 === null && draftScreens.draft_screen_2 === null && draftScreens.draft_screen_3 === null)
                    ? null : previousData || null,
                draft_screen_1: "yes",
            };

            // Create on first save, update on subsequent
            let url = '/create_form_26q';
            if (draftScreens.draft_screen_1 === "yes") {
                url = '/update_form_26q';
                const form26qId = localStorage.getItem('form26q_id');
                if (form26qId) payload.id = parseInt(form26qId);
            }

            try {
                const response = await axios.post(url, payload);
                if (response?.data?.data?.id) {
                    setIsEdit(response.data.data.id);
                    localStorage.setItem('form26q_id', response.data.data.id);
                }
                await getForm26QData();
                toast.success('Data saved successfully');
            } catch (error) {
                toast.error('Failed to save data', { autoClose: 3000, progress: 0 });
                return;
            }
        }

        if (activeStep === 1) {
            await getBusinessEntityDetails();
            const payload = {
                ...employerDetailFormData,
                ...taxDeductionFormData,
                ...personFormData,
                business_entity_id: localStorage.getItem('business_entity_id'),
                csi_file_data: CSIfile,
                csi_file_name: fileName,
                same_as_prev_data: (draftScreens.draft_screen_1 === null && draftScreens.draft_screen_2 === null && draftScreens.draft_screen_3 === null)
                    ? null : previousData || null,
                draft_screen_1: "yes",
                draft_screen_2: "yes",
            };

            const id = localStorage.getItem('form26q_id') || isEdit;
            if (id) payload.id = parseInt(id);

            try {
                await axios.post('/update_form_26q', payload);
                await getForm26QData();
                toast.success('Data saved successfully', { autoClose: 3000, progress: 0 });
            } catch (error) {
                toast.error('Failed to update data', { autoClose: 3000, progress: 0 });
                return;
            }
        }

        setCompletedSteps(prev => new Set(prev).add(activeStep));
        if (activeStep < formSteps.length - 1) {
            setActiveStep(activeStep + 1);
        }

        if (personFormData.responsible_address_same === true) {
            setPersonFormData(prev => ({
                ...prev,
                responsible_name: taxDeductionFormData.name || prev.responsible_name,
                responsible_pan: savedYesPan || prev.responsible_pan,
                responsible_flat_no: taxDeductionFormData.flat_no || prev.responsible_flat_no,
                responsible_premises_name: taxDeductionFormData.premises_name || prev.responsible_premises_name,
                responsible_road_or_street: taxDeductionFormData.road_or_street || prev.responsible_road_or_street,
                responsible_area_or_location: taxDeductionFormData.area_or_location || prev.responsible_area_or_location,
                responsible_town_or_city: taxDeductionFormData.town_or_city || prev.responsible_town_or_city,
                responsible_pin_code: taxDeductionFormData.pin_code || prev.responsible_pin_code,
                responsible_state: taxDeductionFormData.state || prev.responsible_state,
                responsible_telephone_no: taxDeductionFormData.telephone_no || prev.responsible_telephone_no,
                responsible_telephone_alternative: taxDeductionFormData.telephone_alternative || prev.responsible_telephone_alternative,
                responsible_email: taxDeductionFormData.email || prev.responsible_email,
                responsible_email_alternative: taxDeductionFormData.email_alternative || prev.responsible_email_alternative,
                responsible_designation: savedYesDesignation || prev.responsible_designation,
                responsible_address_same: true,
                responsible_mobile_no: prev.responsible_mobile_no
            }));
        } else {
            setPersonFormData(prev => ({
                ...prev,
                responsible_pan: taxDeductorData.particulars_person_responsible_for_deduction?.pan || '',
            }));
        }
    };

    const fileUploader = (event) => {
        if (event.target.files[0]) {
            const file_data = event.target.files[0];
            let fileName = file_data.name;
            setFileName(fileName);
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = function () {
                let file_value = reader.result;
                setCSIfile(file_value);
            };
            document.getElementById("file_value").value = null;
        }
    };

    const handleSubmit = () => {
        if (!fileName || fileName.trim() === "") {
            toast.error("Upload the CSI File", { autoClose: 5000, progress: 0 });
        } else {
            const payload = {
                ...employerDetailFormData,
                ...taxDeductionFormData,
                ...personFormData,
                business_entity_id: localStorage.getItem('business_entity_id'),
                csi_file_data: CSIfile,
                csi_file_name: fileName,
                same_as_prev_data: personFormData.responsible_address_same === true ? "Yes" : "No",
                draft_screen_1: "yes",
                draft_screen_2: "yes",
                draft_screen_3: "yes",
            };

            // ✅ Always include ID for update
            const form26qId = localStorage.getItem('form26q_id');
            if (form26qId) payload.id = parseInt(form26qId);

            const url = isEdit === 0 ? "/create_form_26q" : "/update_form_26q";
            const msg = isEdit === 0 ? "Data saved successfully!" : "Data updated successfully!";

            axios.post(url, payload)
                .then((res) => {
                    if (res?.data.status === false) {
                        toast.error(res?.data?.message || msg, { autoClose: 3000, progress: 0 });
                    } else {
                        toast.success(res?.data?.message || msg, { autoClose: 3000, progress: 0 });

                        getTds26QRpuAnnexureData();
                        getForm26QData();

                        setActiveFormStep((prevActiveFormStep) => prevActiveFormStep + 1);
                        setFileName("");
                    }
                })
                .catch((err) => {
                    toast.error(err?.response?.data?.message || "An error occurred while saving data.", {
                        autoClose: 3000, progress: 0,
                    });
                });
        }
    };


    const handleFile26Q = () => {
        history.push('/26QFiling')
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q'),
            tan: employerDetailFormData.tan
        }
        axios.post('/tds_26Q_filing', payLoadData)
            .then((res) => {

            }).catch((err) => {

            })
    }


    const handleGenerateFUVFile = () => {
        setIsFUVGenerating(true);
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q'),
            tan: employerDetailFormData.tan
        };

        axios.post('/tds_26Q_fuv_file_generation', payLoadData)
            .then((res) => {
                console.log('API Response:', res.data);
                // Check for validation failure and download error file
                if (res.data && res.data.success === false && res.data.status === "validation_failed") {
                    if (res.data.error_file_binary) {
                        const errorFileName = `Error_Report_${localStorage.getItem('quarter_26Q')}_${localStorage.getItem('financial_year_26Q')}.xlsx`;
                        downloadBase64File('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', res.data.error_file_binary, errorFileName);
                    }
                    if (res.data.error_report_file) {
                        const errorReportFileName = res.data.error_report_filename || `Validation_Error_Report_${localStorage.getItem('quarter_26Q')}_${localStorage.getItem('financial_year_26Q')}${res.data.error_report_extension || '.xlsx'}`;
                        const contentType = res.data.error_report_extension === '.xlsx'
                            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            : 'application/octet-stream';
                        downloadBase64File(contentType, res.data.error_report_file, errorReportFileName);
                    }
                    toast.error(res.data.message || 'Validation failed. Please check the error report.', {
                        autoClose: 5000,
                        progress: 0,
                    });
                    return;
                }

                // Check for success
                if (res.data && res.data.success === true) {
                    if (res.data.fvu_zip_file_binary) {
                        const fvuFileName = `FVU_${localStorage.getItem('quarter_26Q')}_${localStorage.getItem('financial_year_26Q')}.zip`;
                        downloadBase64File('application/zip', res.data.fvu_zip_file_binary, fvuFileName);
                    }
                    if (res.data.txt_file_binary) {
                        const txtFileName = `TXT_${localStorage.getItem('quarter_26Q')}_${localStorage.getItem('financial_year_26Q')}.txt`;
                        downloadBase64File('text/plain', res.data.txt_file_binary, txtFileName);
                    }
                    toast.success(res.data.message || 'FUV and TXT files downloaded successfully', {
                        autoClose: 3000,
                        progress: 0,
                    });
                } else {
                    toast.error(res.data.message || 'Failed to generate FUV file', {
                        autoClose: 3000,
                        progress: 0,
                    });
                }
            })
            .catch((err) => {
                console.error('Error:', err);
                toast.error(err?.response?.data?.message || 'An error occurred while generating FUV file', {
                    autoClose: 5000,
                    progress: 0,
                });
            })
            .finally(() => {
                setIsFUVGenerating(false);
            });
    };

    const handleStepClick = (stepIndex) => {
        if (completedSteps.has(stepIndex) || stepIndex <= activeStep) {
            setActiveStep(stepIndex);
        }
        return;
    };

    const typeOfDeductorOptions = [
        { value: 'Artificial Juridical Person (AOP)', label: 'Artificial Juridical Person (AOP)' },
        { value: 'Association of Person (Trust)', label: 'Association of Person (Trust)' },
        { value: 'Autonomous Body (Central Govt.)', label: 'Autonomous Body (Central Govt.)' },
        { value: 'Autonomous Body (State Govt.)', label: 'Autonomous Body (State Govt.)' },
        { value: 'Body of Individuals', label: 'Body of Individuals' },
        { value: 'Branch / Division of Company', label: 'Branch / Division of Company' },
        { value: 'Central Government', label: 'Central Government' },
        { value: 'Company', label: 'Company' },
        { value: 'Firm', label: 'Firm' },
        { value: 'Individual/HUF', label: 'Individual/HUF' },
        { value: 'Local Authority (Central Govt.)', label: 'Local Authority (Central Govt.)' },
        { value: 'Local Authority (State Govt.)', label: 'Local Authority (State Govt.)' },
        { value: 'State Government', label: 'State Government' },
        { value: 'Statutory Body (Central Govt.)', label: 'Statutory Body (Central Govt.)' },
        { value: 'Statutory Body (State Govt.)', label: 'Statutory Body (State Govt.)' }
    ];

    const getFinancialYearOptions = () => {
        const today = new Date();
        const currentMonth = today.getMonth(); // 0-indexed (0 for Jan, 6 for July)
        let currentYear = today.getFullYear();

        // Determine the current financial year
        // If the current month is before April (0, 1, 2), the financial year started in the previous calendar year.
        // Otherwise (April to December), the financial year started in the current calendar year.
        if (currentMonth < 3) { // Months 0, 1, 2 (Jan, Feb, Mar)
            currentYear = currentYear - 1;
        }

        const financialYearOptions = [];

        // Add -5 years
        for (let i = 5; i > 0; i--) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            const value = `${startYear}-${String(endYear).slice(2)}`;
            financialYearOptions.push({ value: value, label: value });
        }

        // Add current financial year
        const currentFYStartYear = currentYear;
        const currentFYEndYear = currentYear + 1;
        const currentFYValue = `${currentFYStartYear}-${String(currentFYEndYear).slice(2)}`;
        financialYearOptions.push({ value: currentFYValue, label: currentFYValue });

        // Add +5 years
        for (let i = 1; i <= 5; i++) {
            const startYear = currentYear + i;
            const endYear = startYear + 1;
            const value = `${startYear}-${String(endYear).slice(2)}`;
            financialYearOptions.push({ value: value, label: value });
        }
        console.log("Financial Year ==>" + JSON.stringify(financialYearOptions));
        return financialYearOptions;
    };



    const FormStep0 = () => {
        return (
            <ValidatorForm
                useRef="formStep0"
                onSubmit={handleFormDetailSubmit}
                onError={(errors) => console.log(errors)}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Financial Year
                            <span style={{ color: 'red' }}>*</span>:
                        </label>

                        <SelectInput
                            choice_id="value"
                            validator={['required']}
                            errorMsg={['Financial Year is required']}
                            choice_name="label"
                            name="financial_year"
                            value={employerDetailFormData.financial_year}
                            textOnchangeFunction={handleChange}
                            choices={financialYearOptions}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Tax Deduction Account Number
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            id="outlined-basic"
                            fullWidth={true}
                            size="small"
                            variant="outlined"
                            name="tan"
                            placeholder="AAAA12345A"
                            value={employerDetailFormData.tan}
                            onChange={handleChange}
                            inputProps={{ maxLength: 10 }}
                            requiredField="*"
                            validators={[
                                "required",
                                "matchRegexp:^[A-Z]{4}[0-9]{5}[A-Z]{1}$",
                            ]}
                            errorMessages={[
                                "TAN is required",
                                "Must be a  Valid TAN number",
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Last Tax Deduction Account Number:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="last_tan"
                            value={employerDetailFormData.last_tan}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Assessment Year
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="assessment_year"
                            value={employerDetailFormData.assessment_year}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["required"]}
                            errorMessages={["Assessment Year is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Permanent Account Number (PAN)
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            placeholder="ABCDE1234F"
                            name="pan"
                            value={employerDetailFormData.pan?.toUpperCase() ?? ""}
                            onChange={handleChange}
                            inputProps={{ maxLength: 10 }}
                            validators={[
                                "required",
                                "matchRegexp:^[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$"
                            ]}
                            errorMessages={[
                                "PAN is required",
                                "Must be a Valid PAN number",
                            ]}
                        />{errors["pan"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {errors["pan"]}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Type of Deductor
                            <span style={{ color: 'red' }}>*</span>:
                        </label>

                        <SelectInput
                            choice_id="value"
                            choice_name="label"
                            name="type_of_deductor"
                            value={employerDetailFormData.type_of_deductor}
                            textOnchangeFunction={handleChange}
                            choices={typeOfDeductorOptions}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />{errors["type_of_deductor"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {"Type of Deductor is required"}
                            </p>
                        )}
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Is this a Revised Return?:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="reverse_charge"
                            name="is_revised_return"
                            value={employerDetailFormData.is_revised_return === true ? 1 : 2}
                            textOnchangeFunction={handleChange}
                            choices={[
                                {
                                    "id": 1,
                                    "reverse_charge": "Yes",
                                },
                                {
                                    "id": 2,
                                    "reverse_charge": "No",
                                }
                            ]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Last Deductor type:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="last_deductor_type"
                            value={employerDetailFormData.last_deductor_type}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Update Deductor Details:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="update_deductor_details"
                            value={employerDetailFormData.update_deductor_details}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Receipt Number of Original Return:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="receipt_number_original"
                            value={employerDetailFormData.receipt_number_original}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Receipt Number of Previous Return:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="receipt_number_previous"
                            value={employerDetailFormData.receipt_number_previous}
                            onChange={handleChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>
                {/* Step Actions */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '1.5%',
                    // paddingTop: '2%',
                    // borderTop: '1px solid #e5e7eb'
                }}>
                    <button
                        onClick={handleFormDetailsBack}
                        // disabled={activeStep === 0}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#ffffff',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        Back
                    </button>
                    <button type="submit"
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Continue
                    </button>
                </div>
            </ValidatorForm>

        )
    }

    const FormStep1 = () => {
        return (
            <ValidatorForm
                useRef="formStep1"
                onError={(errors) => console.log(errors)}
                onSubmit={handleFormDetailSubmit}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Employer Name
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="name"
                            value={taxDeductionFormData.name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 75 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />{errors["name"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {"Employer Name is required"}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Ministry / Dept. Name:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ministry_department_name"
                            value={taxDeductionFormData.ministry_department_name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Branch / Division:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="branch_division"
                            value={taxDeductionFormData.branch_division}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 75 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Ministry / Dept. Name (Others):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ministry_department_name_other"
                            value={taxDeductionFormData.ministry_department_name_other}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            State Name:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="value"
                            name="state_name"
                            value={taxDeductionFormData.state_name}
                            textOnchangeFunction={handleEmployerChange}
                            choices={State}
                            // validators={["required"]}
                            // errorMessages={["This field is required"]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                        {errors["name"] && (
                            <p style={{
                                color: '#ef4444',
                                fontSize: '12px',
                                marginTop: '4px',
                                marginBottom: '0'
                            }}>
                                {"State is required"}
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            DDO Code:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ddo_code"
                            value={taxDeductionFormData.ddo_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            PAO Code:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pao_code"
                            value={taxDeductionFormData.pao_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            DDO Registration Number:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ddo_registration_number"
                            value={taxDeductionFormData.ddo_registration_number}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            PAO Registration Number:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pao_registration_number"
                            value={taxDeductionFormData.pao_registration_number}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Flat No.
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="flat_no"
                            value={taxDeductionFormData.flat_no}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={[
                                "required",
                            ]}
                            errorMessages={["Flat No is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Name of Premises / Building:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="premises_name"
                            value={taxDeductionFormData.premises_name}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Road / Street / Lane:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="road_or_street"
                            value={taxDeductionFormData.road_or_street}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 25 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Area / Location:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="area_or_location"
                            value={taxDeductionFormData.area_or_location}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 25 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Town / City / District:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="town_or_city"
                            value={taxDeductionFormData.town_or_city}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 25 }}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            PIN Code
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="pin_code"
                            value={taxDeductionFormData.pin_code}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 6, }}
                            onKeyPress={(event) => {
                                if (!/^[0-9]$/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            validators={[
                                "required",
                                'matchRegexp:^[0-9]{6}$']}
                            errorMessages={["Pin Code is required", 'Must be a 6-digit pincode']}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            State
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <SelectInput
                            choice_id="value"
                            choice_name="value"
                            name="state"
                            value={taxDeductionFormData.state}
                            textOnchangeFunction={handleEmployerChange}
                            choices={State}
                            validators={[
                                "required"]}
                            errorMessages={["State is required"]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Telephone No:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="telephone_no"
                            value={taxDeductionFormData.telephone_no}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 10 }}
                            validators={["required", "matchRegexp:^[1-9]{1}[0-9]{9}$"]}
                            errorMessages={["This field is required", "Invalid mobile number"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Telephone No (Alternative):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="telephone_alternative"
                            value={taxDeductionFormData.telephone_alternative}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 10 }}
                            validators={["matchRegexp:^[0-9]{10}$"]}
                            errorMessages={["Invalid mobile number"]}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4}>
                        <label>
                            E-mail:
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="email"
                            value={taxDeductionFormData.email}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 75 }}
                            validators={["required", "isEmail"]}
                            errorMessages={["This field is required", "Email is not Valid"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            E-mail (Alternative):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="email_alternative"
                            value={taxDeductionFormData.email_alternative}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                            validators={["isEmail"]}
                            errorMessages={["Email is not Valid"]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Account Office Identification Number (AIN):
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="ao_ain"
                            value={taxDeductionFormData.ao_ain}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={4} mt={0.7}>
                        <label style={{ display: 'block', marginBottom: '3px' }}>
                            Has Address Changed since Last Return?:
                        </label>
                        <SelectInput
                            choice_id="id"
                            choice_name="reverse_charge"
                            name="has_address_changed"
                            value={taxDeductionFormData.has_address_changed === true ? 1 : 2}
                            textOnchangeFunction={handleEmployerChange}
                            choices={[
                                {
                                    "id": 1,
                                    "reverse_charge": "Yes",
                                },
                                {
                                    "id": 2,
                                    "reverse_charge": "No",
                                }
                            ]}
                            sx={{
                                height: '40px', // Ensure consistent height
                                '& .MuiSelect-select': {
                                    padding: '10px 14px', // Consistent padding
                                    fontSize: '1rem',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <label>
                            Goods and Service Tax Number (GSTN):
                            <span style={{ color: "red" }}>*</span>:
                        </label>
                        <TextValidator
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="gstn"
                            placeholder="22ABCDE1234F1Z5"
                            // value={taxDeductionFormData.gstn || localStorage.getItem('gst')}
                            value={taxDeductionFormData.gstn}
                            validators={["required", "matchRegexp:^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[CZ]{1}[0-9A-Za-z]{1}$"]}
                            errorMessages={["GSTIN is required", "Must be a Valid GSTN number"]}
                            onChange={handleEmployerChange}
                            inputProps={{ maxLength: 15 }}
                        />

                    </Grid>
                </Grid>
                {/* Step Actions */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '1.5%',
                    // paddingTop: '2%',
                    // borderTop: '1px solid #e5e7eb'
                }}>
                    <button
                        onClick={handleFormDetailsBack}
                        // disabled={activeStep === 0}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#ffffff',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        Back
                    </button>
                    <button type="submit"
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#2563eb',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Continue
                    </button>
                </div>
            </ValidatorForm>
        )
    }

    const FormStep2 = () => {
        return (
            <>
                <ValidatorForm
                    useRef="formStep2"
                    onError={(errors) => console.log(errors)}
                    onSubmit={handleSubmit}
                >
                    {/* All your existing form content here */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} mt={0.7}>
                            <label>
                                Same as previous data:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_address_same"
                                value={personFormData.responsible_address_same === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Name
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_name"
                                value={personFormData.responsible_name}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 75 }}
                                validators={["required"]}
                                errorMessages={["Name is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Permanent Account Number (PAN)<span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_pan"
                                placeholder="ABCDE1234F"
                                value={personFormData.responsible_pan?.toUpperCase() ?? ""}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 10 }}
                                validators={[
                                    "required",
                                    "matchRegexp:^[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$",
                                    "isPANDifferent"
                                ]}
                                errorMessages={[
                                    "PAN is required",
                                    "Must be a Valid PAN number",
                                    "Responsible person PAN cannot be same as Deductor PAN"
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Designation<span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_designation"
                                value={personFormData.responsible_designation}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 20 }}
                                validators={["required"]}
                                errorMessages={["Designation is required"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Flat No.
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_flat_no"
                                value={personFormData.responsible_flat_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["Flat No is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Name of Premises / Building:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_premises_name"
                                value={personFormData.responsible_premises_name}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25 }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Road / Street / Lane
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_road_or_street"
                                value={personFormData.responsible_road_or_street}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Area / Location
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_area_or_location"
                                value={personFormData.responsible_area_or_location}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Town / City / District
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_town_or_city"
                                value={personFormData.responsible_town_or_city}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 25 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                PIN Code
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_pin_code"
                                value={personFormData.responsible_pin_code}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 6, }}
                                onKeyPress={(event) => {
                                    if (!/^[0-9]$/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                errorMessages={["Pin Code is required", "Must be a 6-digit pincode"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4} mt={0.7}>
                            <label style={{ display: 'block', marginBottom: '3px' }}>
                                State
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <SelectInput
                                choice_id="value"
                                choice_name="value"
                                name="responsible_state"
                                value={personFormData.responsible_state}
                                textOnchangeFunction={handleDeductorChange}
                                choices={State}
                                validators={["required"]}
                                errorMessages={["State is required"]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Telephone No
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_telephone_no"
                                value={personFormData.responsible_telephone_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 10 }}
                                validators={["required", "matchRegexp:^[0-9]{10}$"]}
                                errorMessages={["This field is required", "Invalid mobile number"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Telephone No (Alternative):
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_telephone_alternative"
                                value={personFormData.responsible_telephone_alternative}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 10 }}
                                validators={["matchRegexp:^[0-9]{10}$"]}
                                errorMessages={["Invalid mobile number"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4}>
                            <label>
                                E-mail
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_email"
                                value={personFormData.responsible_email}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 75 }}
                                validators={["required", "isEmail"]}
                                errorMessages={["This field is required", "Email is not Valid"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                E-mail (Alternative):
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_email_alternative"
                                value={personFormData.responsible_email_alternative}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 75 }}
                                validators={["isEmail"]}
                                errorMessages={["Email is not Valid"]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Mobile No.
                            </label>
                            <TextValidator
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="responsible_mobile_no"
                                value={personFormData.responsible_mobile_no}
                                onChange={handleDeductorChange}
                                inputProps={{ maxLength: 100 }}
                                validators={["matchRegexp:^[1-9]{1}[0-9]{9}$"]}
                                errorMessages={["Invalid mobile number"]}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} sm={4} mt={1}>
                            <label style={{ display: 'block', marginBottom: '3px' }}>
                                Has Address Changed since Last Return?:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_address_changed"
                                value={personFormData.responsible_address_changed === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Receipt No. of earlier Statement filed for Form:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="responsible_receipt_number"
                                value={personFormData.responsible_receipt_number === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <label>
                                Has regular statement for Form 26Q filed for earlier period:
                            </label>
                            <SelectInput
                                choice_id="id"
                                choice_name="reverse_charge"
                                name="filed_earlier_period"
                                value={personFormData.filed_earlier_period === true ? 1 : 2}
                                textOnchangeFunction={handleDeductorChange}
                                choices={[
                                    {
                                        "id": 1,
                                        "reverse_charge": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "reverse_charge": "No",
                                    }
                                ]}
                                sx={{
                                    height: '40px', // Ensure consistent height
                                    '& .MuiSelect-select': {
                                        padding: '10px 14px', // Consistent padding
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        </Grid>
                        {personFormData.filed_earlier_period === true && (
                            <Grid item xs={12} sm={4}>
                                <label>
                                    Previous Statement Number<span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="previous_statement_number"
                                    value={personFormData.previous_statement_number || ''}
                                    onChange={handleDeductorChange}
                                    inputProps={{ maxLength: 15 }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    validators={["required", "matchRegexp:^[0-9]{1,15}$"]}
                                    errorMessages={[
                                        "Previous Statement Number is required",
                                        "Only numbers allowed (max 15 digits)"
                                    ]}
                                />
                            </Grid>
                        )}
                    </Grid>

                    <BoxWrapper boxTitle="CSI File Upload" >
                        <Grid container spacing={3} alignItems="center">
                            <Grid item xs={3} md={1}>
                                <label
                                    className="button-primary"
                                    style={{
                                        width: "100%",
                                        textAlign: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    Browse
                                    <input
                                        id="file_value"
                                        name="CSIfile"
                                        accept=".csi"
                                        type="file"
                                        hidden
                                        onChange={fileUploader}
                                    />
                                </label>
                            </Grid>
                            <Grid item xs={4} md={4}>
                                <TextValidator
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    placeholder="Choose file"
                                    value={fileName}
                                    name="csi_file_uploader"
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4} md={2}>
                                <button
                                    type="button"
                                    className="button-primary"
                                    onClick={handleOpenAutoDownload}
                                    style={{
                                        width: "auto",
                                        padding: "6px 14px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Auto Download
                                </button>
                            </Grid>
                            <Grid item xs={4} md={2}>
                                <button
                                    type="button"
                                    onClick={handleDownloadCSIFile}
                                    disabled={isDownloadingCSI}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "6px",
                                        width: "auto",
                                        padding: "6px 12px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: isDownloadingCSI ? "#94a3b8" : "#0d3f66",
                                        backgroundColor: "#ffffff",
                                        border: `1px solid ${isDownloadingCSI ? "#e2e8f0" : "#0d3f66"}`,
                                        borderRadius: "6px",
                                        cursor: isDownloadingCSI ? "not-allowed" : "pointer",
                                        whiteSpace: "nowrap",
                                        transition: "all 0.2s ease-in-out",
                                    }}
                                    onMouseOver={(e) => {
                                        if (!isDownloadingCSI) {
                                            e.currentTarget.style.backgroundColor = "#0d3f66";
                                            e.currentTarget.style.color = "#ffffff";
                                        }
                                    }}
                                    onMouseOut={(e) => {
                                        if (!isDownloadingCSI) {
                                            e.currentTarget.style.backgroundColor = "#ffffff";
                                            e.currentTarget.style.color = "#0d3f66";
                                        }
                                    }}
                                >
                                    {isDownloadingCSI ? (
                                        <svg
                                            width="14" height="14" viewBox="0 0 16 16"
                                            style={{ animation: "spin 0.9s linear infinite", flexShrink: 0 }}
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="8" cy="8" r="6"
                                                fill="none" stroke="currentColor"
                                                strokeWidth="2" strokeDasharray="28"
                                                strokeDashoffset="10" strokeLinecap="round"
                                            />
                                        </svg>
                                    ) : (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7 10 12 15 17 10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                    )}
                                    {isDownloadingCSI ? "Downloading..." : "Download CSI"}
                                </button>
                            </Grid>
                        </Grid>
                    </BoxWrapper>

                    {/* Step Actions - Both buttons inside ValidatorForm on same line */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: '1.5%',
                        // paddingTop: '2%',
                        // borderTop: '1px solid #e5e7eb'
                    }}>
                        <button
                            type="button"
                            onClick={handleFormDetailsBack}
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#ffffff',
                                color: '#374151',
                                border: '1px solid #d1d5db',
                                borderRadius: '12px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Back
                        </button>
                        <button type="submit"
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#1d4ed8',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#30b614'}
                        >
                            Submit
                        </button>
                    </div>
                </ValidatorForm>
            </>
        )
    }

    const financialYearOptions = getFinancialYearOptions();

    const formSteps = [
        {
            id: 0,
            title: 'Particulars of Deductor (Employer)',
            description: 'Basic details of the deductor (Employer)',
            content: FormStep0 // ✅ Pass function reference
        },
        {
            id: 1,
            title: 'Deduction of Tax',
            description: 'Particulars of the Person Responsible for Deduction of Tax',
            content: FormStep1 // ✅ Pass function reference
        },
        {
            id: 2,
            title: 'Person Responsible',
            description: 'Details of person responsible for deduction of tax',
            content: FormStep2 // ✅ Pass function reference
        }
    ];


    const StepIndicator = ({ step, isActive, isCompleted, onClick }) => (
        <div
            onClick={() => onClick(step.id)}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px',
                borderRadius: '12px',
                backgroundColor: isActive ? '#eff6ff' : isCompleted ? '#f0f9ff' : '#f8fafc',
                border: isActive ? '2px solid #2563eb' : '1px solid #e5e7eb',
                cursor: (isCompleted || step.id <= activeStep) ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease-in-out',
                opacity: (isCompleted || step.id <= activeStep) ? 1 : 0.6,
                marginBottom: '12px'
            }}
        >
            <div
                style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: isCompleted ? '#10b981' : isActive ? '#2563eb' : '#e5e7eb',
                    color: isCompleted || isActive ? '#ffffff' : '#6b7280',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '600',
                    marginRight: '12px',
                    flexShrink: 0
                }}
            >
                {isCompleted ? <CheckIcon size={16} /> : step.id + 1}
            </div>
            <div style={{ flex: 1 }}>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: isActive ? '#2563eb' : '#374151',
                    marginBottom: '4px'
                }}>
                    {step.title}
                </div>
                <div style={{
                    fontSize: '14px',
                    color: '#6b7280'
                }}>
                    {step.description}
                </div>
            </div>
            {isActive && <ChevronRightIcon size={20} color="#2563eb" />}
        </div>
    );

    const challanColumns = [
        { field: 'sr_no', headerName: 'Sr No', flex: 1, minWidth: 80, filterable: true },
        { field: 'challan_no', headerName: 'Challan No', flex: 1, minWidth: 120, filterable: true },
        { field: 'challan_date', headerName: 'Challan Date', flex: 1, minWidth: 120, filterable: true },
        { field: 'bsr_code', headerName: 'BSR Code', flex: 1, minWidth: 120, filterable: true },
        { field: 'section', headerName: 'Section', flex: 1, minWidth: 100, filterable: true },
        {
            field: 'tds',
            headerName: 'TDS',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'surcharge',
            headerName: 'Surcharge',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'cess',
            headerName: 'CESS',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'interest',
            headerName: 'Interest',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'penalty',
            headerName: 'Penalty',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'fee',
            headerName: 'Fees',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'total',
            headerName: 'Total',
            flex: 1,
            minWidth: 120,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
    ];


    // ---- Annexure columns: filterable enabled on every column, including Nature of Payment via valueGetter ----
    const annexureColumns = [
        { field: 'challan_no', headerName: 'Challan No', flex: 1, minWidth: 120, filterable: true },
        {
            field: 'code',
            headerName: 'Code',
            flex: 1,
            minWidth: 160,
            filterable: true,
            sortable: true,
            // NEW — the API sends `available_codes: [...]`, not a single `code` field.
            // Single-code rows show the code as plain text; rows with more than one
            // available code expose a dropdown (see renderCell) so the user can pick
            // which code applies, which in turn drives the Nature of Payment options
            // fetched from get_nature_of_payment_options.
            valueGetter: (params) => {
                const codes = getRowCodes(params.row);
                if (codes.length <= 1) return codes.join(', ');
                return codeSelections[params.row._rowKey] || codes.join(', ');
            },
            renderCell: (params) => {
                const codes = getRowCodes(params.row);
                const rowId = params.row._rowKey;

                if (codes.length <= 1) {
                    return (
                        <Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                px: 1.5,
                            }}
                        >
                            <Typography variant="body2" noWrap title={codes.join(', ') || '-'}>
                                {codes.join(', ') || '-'}
                            </Typography>
                        </Box>
                    );
                }

                const selectedCode = codeSelections[rowId] || '';

                return (
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 0.5, width: '100%' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FormControl
                            size="small"
                            fullWidth
                            sx={{ my: 0.5 }}
                        >
                            <Select
                                value={selectedCode}
                                displayEmpty
                                onChange={(e) => handleCodeSelect(rowId, params.row, e.target.value)}
                                sx={{
                                    '& .MuiSelect-select': {
                                        py: 0.75,
                                    },
                                }}
                            >
                                <MenuItem value="" disabled>
                                    <em>Select Code</em>
                                </MenuItem>
                                {codes.map((c) => (
                                    <MenuItem key={c} value={c}>
                                        {c}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                );
            },
        },
{
    field: 'nature_of_payment_select',
    headerName: 'Nature of Payment',
    flex: 1.8,
    minWidth: 320,
    sortable: true,
    filterable: true,
    valueGetter: (params) => {
        const options = getNatureOfPaymentOptionsForRow(params.row);
        const saved = params.row.nature_of_payment_select
            || natureOfPaymentSelections[params.row._rowKey]?.nature_of_payment
            || '';

        if (options.length === 0) {
            // options not loaded yet → still show whatever was saved
            return saved ? formatNatureOfPaymentLabel(saved) : 'Not Applicable';
        }
        if (options.length === 1) {
            return formatNatureOfPaymentLabel(options[0]);
        }
        const selected = natureOfPaymentSelections[params.row._rowKey]?.nature_of_payment || saved || '';
        return selected ? formatNatureOfPaymentLabel(selected) : '';
    },
    renderCell: (params) => {
        const options = getNatureOfPaymentOptionsForRow(params.row);
        const rowId = params.row._rowKey;
        const codes = getRowCodes(params.row);
        const selectedCode = codeSelections[rowId] || (codes.length === 1 ? codes[0] : null);
        const isLoading = selectedCode && loadingNatureOptionsKeys.has(`${params.row.repository_id}_${selectedCode}`);

        // ---------- already saved value from API ----------
        const savedValue =
            natureOfPaymentSelections[rowId]?.nature_of_payment ||
            params.row.nature_of_payment_select ||
            '';

        if (isLoading) {
            return (
                <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', px: 1.5 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                        Loading…
                    </Typography>
                </Box>
            );
        }

        // No options yet (or still loading) → just show the saved value
        if (options.length === 0) {
            return (
                <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', px: 1.5 }}>
                    <Typography
                        variant="body2"
                        sx={{ color: savedValue ? 'text.primary' : 'text.disabled', fontStyle: savedValue ? 'normal' : 'italic' }}
                        noWrap
                        title={savedValue ? formatNatureOfPaymentLabel(savedValue) : 'Not Applicable'}
                    >
                        {savedValue ? formatNatureOfPaymentLabel(savedValue) : 'Not Applicable'}
                    </Typography>
                </Box>
            );
        }

        // Exactly one option → show it as plain text
        if (options.length === 1) {
            return (
                <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', px: 1.5 }}>
                    <Typography variant="body2" noWrap title={formatNatureOfPaymentLabel(options[0])}>
                        {formatNatureOfPaymentLabel(options[0])}
                    </Typography>
                </Box>
            );
        }

        // Multiple options → dropdown
        const selectedValue = natureOfPaymentSelections[rowId]?.nature_of_payment || savedValue || '';

        return (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }} onClick={(e) => e.stopPropagation()}>
                <FormControl size="small" fullWidth sx={{ my: 0.5 }}>
                    <Select
                        value={selectedValue}
                        displayEmpty
                        onChange={(e) => handleNatureOfPaymentSelect(rowId, params.row, e.target.value)}
                        renderValue={(selected) =>
                            selected
                                ? formatNatureOfPaymentLabel(selected)
                                : <em style={{ color: '#9ca3af' }}>Select</em>
                        }
                        sx={{ '& .MuiSelect-select': { py: 0.75 } }}
                        MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
                    >
                        {options.map((opt) => (
                            <MenuItem key={opt} value={opt}>
                                {formatNatureOfPaymentLabel(opt)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        );
    },
},
        { field: 'section', headerName: 'Section', flex: 1, minWidth: 100, filterable: true },
        { field: 'pan', headerName: 'PAN', flex: 1, minWidth: 100, filterable: true },
        { field: 'name', headerName: 'Name', flex: 1, minWidth: 120, filterable: true },
        { field: 'date_of_payment', headerName: 'Date of Payment', flex: 1, minWidth: 120, filterable: true },
        { field: 'date_of_deduction', headerName: 'Date of Deduction', flex: 1, minWidth: 120, filterable: true },
        {
            field: 'tds_percentage',
            headerName: 'TDS Percentage',
            flex: 1,
            minWidth: 130,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'tds',
            headerName: 'TDS',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'surcharge',
            headerName: 'Surcharge',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'cess',
            headerName: 'CESS',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'tax',
            headerName: 'Tax',
            flex: 1,
            minWidth: 110,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
        {
            field: 'amount_paid',
            headerName: 'Amount Paid',
            flex: 1,
            minWidth: 120,
            filterable: true,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography variant="body2">{formatCurrency(params.value)}</Typography>
                </Stack>
            ),
        },
    ];

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleDownloadReport = () => {
        const financial_year = localStorage.getItem('financial_year_26Q')
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `26Q Annexure RPU.xlsx`;

        setIsExporting(true);

        axios
            .post(`/generate_tds_rpu_excel_report`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                financial_year: financial_year,
                quarter: localStorage.getItem('quarter_26Q')
            })
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setIsExporting(false);
            })
    }

    // NEW — resolves the code a given row is "working against" right now: the single
    // available code when there's only one, or the value the user picked from the
    // Code column dropdown when there are several. Returns null when the row has
    // multiple codes and none has been chosen yet.
    const getEffectiveCodeForRow = (row) => {
        const codes = getRowCodes(row);
        if (codes.length === 0) return null;
        if (codes.length === 1) return codes[0];
        return codeSelections[row._rowKey] || null;
    };

    // NEW — returns the (already-fetched) nature-of-payment options for a row's
    // effective code, or an empty array when there's no effective code yet or the
    // options haven't arrived from get_nature_of_payment_options yet.
const getNatureOfPaymentOptionsForRow = (row) => {
    const codes = getRowCodes(row);
    const selectedCode =
        codeSelections[row._rowKey] ||
        (codes.length === 1 ? codes[0] : null);

    if (!selectedCode) return [];

    const cacheKey = `${row.repository_id}_${selectedCode}`;
    return natureOfPaymentOptionsByCode[cacheKey] || [];
};

    // NEW — calls get_nature_of_payment_options for a given repository_id/code
    // combination, caches the (normalized) result, and — if it turns out there's
    // only a single applicable option — auto-fills that value for every row on this
    // combination that doesn't already carry a selection (mirrors the old
    // single-option auto-fill behaviour, but driven by the live API response
    // instead of the removed hardcoded map).
const fetchNatureOfPaymentOptionsForCode = async (repositoryId, code, force = false, rows = annexureData) => {
    if (!repositoryId || !code) return [];
    const cacheKey = `${repositoryId}_${code}`;

    // already have it (skipped when force = true, e.g. on data reload)
    if (!force && natureOfPaymentOptionsByCode[cacheKey]) {
        return natureOfPaymentOptionsByCode[cacheKey];
    }
    // already in flight (skipped when force = true)
    if (!force && loadingNatureOptionsKeys.has(cacheKey)) return [];

    setLoadingNatureOptionsKeys((prev) => new Set(prev).add(cacheKey));

    try {
        const res = await axios.post('/get_nature_of_payment_options', {
            repository_id: repositoryId,
            code: code,
        });

        const options = normalizeNatureOptions(res?.data);

        setNatureOfPaymentOptionsByCode((prev) => ({
            ...prev,
            [cacheKey]: options,
        }));

        // auto-select when the API returns exactly one option
        // and the row does not already have a saved value
        if (options.length === 1) {
            setNatureOfPaymentSelections((prev) => {
                const next = { ...prev };
                rows.forEach((row) => {
                    const codes = getRowCodes(row);
                    const selectedCode = codeSelections[row._rowKey] || (codes.length === 1 ? codes[0] : null);
                    if (selectedCode === code && row.repository_id == repositoryId) {
                        // only fill if nothing is already selected
                        if (!next[row._rowKey]?.nature_of_payment) {
                            next[row._rowKey] = {
                                id: row.id,
                                nature_of_payment: options[0],
                            };
                        }
                    }
                });
                return next;
            });
        }

        return options;
    } catch (err) {
        console.error('get_nature_of_payment_options failed', err);
        return [];
    } finally {
        setLoadingNatureOptionsKeys((prev) => {
            const next = new Set(prev);
            next.delete(cacheKey);
            return next;
        });
    }
};

    // NEW — fired when the user picks a code from the multi-code Code column
    // dropdown. Records the choice, clears any nature-of-payment value the row may
    // have had (it belonged to the previous code, if any), marks the row as
    // changed, and hits get_nature_of_payment_options for the newly chosen code.
    const handleCodeSelect = (rowId, row, code) => {
        setCodeSelections((prev) => ({
            ...prev,
            [rowId]: code,
        }));

        setNatureOfPaymentSelections((prev) => {
            if (!prev[rowId]) return prev;
            const updated = { ...prev };
            delete updated[rowId];
            return updated;
        });

        setChangedRowKeys((prev) => {
            const updated = new Set(prev);
            updated.add(rowId);
            return updated;
        });

        fetchNatureOfPaymentOptionsForCode(row.repository_id, code);
    };

    // Updates only the single row that was changed via its dropdown, records that
    // row's key as "changed" so Save knows to include it, and remembers this value
    // as the "pending Apply All" value. The common Apply All button (near Export)
    // only turns on once this is set AND a grid filter is active.
    const handleNatureOfPaymentSelect = (rowId, row, value) => {
        setNatureOfPaymentSelections((prev) => ({
            ...prev,
            [rowId]: {
                id: row.id,
                nature_of_payment: value,
            },
        }));
        setChangedRowKeys((prev) => {
            const updated = new Set(prev);
            updated.add(rowId);
            return updated;
        });
        setPendingApplyValue(value);
    };

    // ---- Filter helpers for the Annexure grid ----
    // Reads the current DataGridPro filterModel and tells us which items are
    // actually "active" (have a usable value). Handles both the v5 (columnField /
    // operatorValue) and v6 (field / operator) filter item shapes.
    const getActiveFilterItems = () => {
        const items = filterModel?.items || [];
        return items.filter((item) => item && item.value !== undefined && item.value !== '' && item.value !== null);
    };

    const hasActiveFilter = getActiveFilterItems().length > 0;

    const matchesFilterItem = (row, item) => {
        const field = item.field || item.columnField;
        const operator = item.operator || item.operatorValue || 'contains';

        let cellValue;
        if (field === 'nature_of_payment_select') {
            // NEW — use getNatureOfPaymentOptionsForRow (backed by
            // get_nature_of_payment_options) instead of the old static-map lookup.
            const options = getNatureOfPaymentOptionsForRow(row);
            if (options.length === 0) cellValue = 'Not Applicable';
            else if (options.length === 1) cellValue = formatNatureOfPaymentLabel(options[0]);
            else {
                const selected = natureOfPaymentSelections[row._rowKey]?.nature_of_payment;
                cellValue = selected ? formatNatureOfPaymentLabel(selected) : '';
            }
        } else if (field === 'code') {
            // NEW — filter on the currently selected/available code(s) for the row.
            const codes = getRowCodes(row);
            cellValue = codes.length <= 1 ? codes.join(', ') : (codeSelections[row._rowKey] || codes.join(', '));
        } else {
            cellValue = row[field];
        }

        const cellStr = (cellValue ?? '').toString().toLowerCase();
        const filterStr = (item.value ?? '').toString().toLowerCase();

        switch (operator) {
            case 'equals':
                return cellStr === filterStr;
            case 'startsWith':
                return cellStr.startsWith(filterStr);
            case 'endsWith':
                return cellStr.endsWith(filterStr);
            case '=':
                return Number(cellValue) === Number(item.value);
            case '!=':
                return Number(cellValue) !== Number(item.value);
            case '>':
                return Number(cellValue) > Number(item.value);
            case '>=':
                return Number(cellValue) >= Number(item.value);
            case '<':
                return Number(cellValue) < Number(item.value);
            case '<=':
                return Number(cellValue) <= Number(item.value);
            case 'contains':
            default:
                return cellStr.includes(filterStr);
        }
    };

    // Rows currently matching the Annexure grid's filter. When no filter is
    // active this intentionally returns an empty set — Apply All should never
    // act on the whole unfiltered dataset.
    const getFilteredAnnexureRows = () => {
        const activeItems = getActiveFilterItems();
        if (activeItems.length === 0) return [];
        return annexureData.filter((row) => activeItems.every((item) => matchesFilterItem(row, item)));
    };

    // How many of the currently filtered rows would actually receive the pending
    // value (only rows whose resolved code's options support that value). Shown
    // as a count on the Apply All button.
    const applyAllMatchCount = (() => {
        if (!hasActiveFilter || !pendingApplyValue) return 0;
        const rows = getFilteredAnnexureRows();
        // NEW — use getNatureOfPaymentOptionsForRow instead of the old static-map lookup.
        return rows.filter((row) => getNatureOfPaymentOptionsForRow(row).includes(pendingApplyValue)).length;
    })();

    const isApplyAllEnabled = hasActiveFilter && !!pendingApplyValue && applyAllMatchCount > 0 && !isViewOnly;

    // The single Apply All action (near Export). Applies the last-picked dropdown
    // value to every row currently matching the grid filter whose resolved code's
    // options support that value. Disabled unless a filter is active and a value
    // was picked via onChange — never touches the full unfiltered dataset.
    const handleApplyAllToFiltered = () => {
        if (!isApplyAllEnabled) return;

        console.log('========== APPLY ALL CLICKED ==========');
        console.log('1. Total rows in annexureData (entire grid):', annexureData.length);
        console.log('2. Current filterModel:', JSON.stringify(filterModel, null, 2));
        console.log('3. Active filter items:', getActiveFilterItems());
        console.log('4. pendingApplyValue:', pendingApplyValue);

        const filteredRows = getFilteredAnnexureRows();
        console.log('5. Rows that match the current filter (filteredRows.length):', filteredRows.length);
        console.log('6. Filtered rows details (id, _rowKey, available_codes, effective code, current selection):', filteredRows.map(r => ({
            id: r.id,
            _rowKey: r._rowKey,
            available_codes: getRowCodes(r),
            effective_code: getEffectiveCodeForRow(r),
            currentNature: natureOfPaymentSelections[r._rowKey]?.nature_of_payment || '(none)'
        })));

        const touchedKeys = [];
        filteredRows.forEach((row) => {
            // NEW — use getNatureOfPaymentOptionsForRow instead of the old static-map lookup.
            const options = getNatureOfPaymentOptionsForRow(row);
            if (options.includes(pendingApplyValue)) {
                touchedKeys.push(row._rowKey);
            }
        });

        console.log('7. Rows that will actually receive the value (options includes pendingApplyValue):', touchedKeys.length);
        console.log('8. touchedKeys (_rowKey list):', touchedKeys);
        console.log('9. Detailed list of rows that will be applied:', filteredRows
            .filter(row => getNatureOfPaymentOptionsForRow(row).includes(pendingApplyValue))
            .map(r => ({
                id: r.id,
                _rowKey: r._rowKey,
                available_codes: getRowCodes(r),
                effective_code: getEffectiveCodeForRow(r),
                nature_of_payment: pendingApplyValue
            }))
        );

        if (touchedKeys.length === 0) {
            console.log('10. No matching rows → early return');
            toast.info('No matching rows found for this selection.', { autoClose: 2000, progress: 0 });
            return;
        }

        setNatureOfPaymentSelections((prev) => {
            const updated = { ...prev };
            filteredRows.forEach((row) => {
                // NEW — use getNatureOfPaymentOptionsForRow instead of the old static-map lookup.
                const options = getNatureOfPaymentOptionsForRow(row);
                if (options.includes(pendingApplyValue)) {
                    updated[row._rowKey] = {
                        id: row.id,
                        nature_of_payment: pendingApplyValue,
                    };
                }
            });
            console.log('11. natureOfPaymentSelections after Apply All (only changed keys):',
                Object.fromEntries(
                    Object.entries(updated).filter(([k]) => touchedKeys.includes(k))
                )
            );
            return updated;
        });

        setChangedRowKeys((prev) => {
            const updated = new Set(prev);
            touchedKeys.forEach((k) => updated.add(k));
            console.log('12. changedRowKeys after Apply All (size):', updated.size);
            console.log('13. changedRowKeys content:', Array.from(updated));
            return updated;
        });

        toast.success(`Applied "${formatNatureOfPaymentLabel(pendingApplyValue)}" to ${touchedKeys.length} record${touchedKeys.length === 1 ? '' : 's'}.`, {
            autoClose: 2500,
            progress: 0,
        });

        // Reset so the button goes back to disabled until the next onChange.
        setPendingApplyValue('');
        console.log('========== APPLY ALL FINISHED ==========');
    };


const isAllNatureOfPaymentSelected = () => {
    if (!annexureData || annexureData.length === 0) return false;

    return annexureData.every((row) => {
        // 1. Value the user has changed in the dropdown (if any)
        const fromState = natureOfPaymentSelections[row._rowKey]?.nature_of_payment;

        // 2. Value that already came from the API
        const fromApi = row.nature_of_payment_select;

        const value = fromState || fromApi;

        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return !!value && String(value).trim() !== '';
    });
};


    // Add this helper near formatNatureOfPaymentLabel
    const normalizeForCompare = (val) =>
        (val || '').toString().trim().toLowerCase().replace(/[\s-]+/g, '_');

    // Only ever sends rows the user actually touched (tracked in changedRowKeys),
    // deduped by id — this is what fixes "one row changed but everything got sent".
    // Payload shape is unchanged: { id, nature_of_payment } per row.
const handleSaveAnnexureSelections = () => {
    const seenIds = new Set();
    const selections = [];

    annexureData.forEach((row) => {
        const rowId = row._rowKey;
        const options = getNatureOfPaymentOptionsForRow(row);

        let nature_of_payment = '';
        if (options.length === 1) {
            // single applicable option (same rule as before)
            nature_of_payment = options[0];
        } else {
            // user change / Apply All / initially-bound value
            nature_of_payment = natureOfPaymentSelections[rowId]?.nature_of_payment || '';
            // fall back to the saved API value, unless the user changed this row's code
            if (!nature_of_payment && !changedRowKeys.has(rowId)) {
                nature_of_payment = row.nature_of_payment_select || '';
            }
        }

        if (!nature_of_payment) return;      // nothing selected for this row
        if (seenIds.has(row.id)) return;     // dedupe by id (unchanged)
        seenIds.add(row.id);

            selections.push({ id: row.id, nature_of_payment, code: getEffectiveCodeForRow(row) || row.code_select || null, });
    });

    setIsSavingSelections(true);
    const payload = {
        business_entity_id: localStorage.getItem('business_entity_id'),
        financial_year: localStorage.getItem('financial_year_26Q'),
        quarter: localStorage.getItem('quarter_26Q'),
        selections: selections,
    };

    axios.post('/save_annexure1_code_selection', payload)
        .then((res) => {
            if (res?.data?.status === false) {
                toast.error(res?.data?.message || 'Failed to save selections', { autoClose: 3000, progress: 0 });
            } else {
                toast.success(res?.data?.message || 'Nature of payment selections saved successfully', { autoClose: 3000, progress: 0 });

                setInitialNatureOfPaymentSelections((prev) => {
                    const updated = { ...prev };
                    selections.forEach((sel) => {
                        const matchingRow = annexureData.find((row) => row.id === sel.id);
                        if (matchingRow) {
                            updated[matchingRow._rowKey] = { id: sel.id, nature_of_payment: sel.nature_of_payment };
                        }
                    });
                    return updated;
                });

                setChangedRowKeys(new Set());
            }
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message || 'An error occurred while saving selections.', {
                autoClose: 3000, progress: 0,
            });
        })
        .finally(() => {
            setIsSavingSelections(false);
        });
};

    const handleOpenAutoDownload = () => {
        setAutoDownloadPhone(taxDeductionFormData.telephone_no || '');
        setOtpSent(false);
        setOtpValue('');
        setOtpReferenceId('');
        setAutoDownloadBusinessEntityId(localStorage.getItem('business_entity_id') || '');
        setAutoDownloadOpen(true);
    };

    const handleCloseAutoDownload = () => {
        setAutoDownloadOpen(false);
        setOtpSent(false);
        setOtpValue('');
        setOtpReferenceId('');
    };

    const handleSendOtp = () => {
        if (!autoDownloadPhone || autoDownloadPhone.trim() === '') {
            toast.error('Please enter a valid phone number', { autoClose: 3000, progress: 0 });
            return;
        }
        setIsSendingOtp(true);
        const payload = {
            tan: employerDetailFormData.tan,
            business_entity_id: localStorage.getItem('business_entity_id'),
            mobile_number: autoDownloadPhone,
            financial_year: employerDetailFormData.financial_year,
            quarter: employerDetailFormData.quarter,
        };
        axios.post('/generate_csi_otp', payload)
            .then((res) => {
                if (res?.data?.status === false) {
                    toast.error(res?.data?.message || 'Failed to send OTP', { autoClose: 3000, progress: 0 });
                } else {
                    toast.success(res?.data?.message || 'OTP sent successfully', { autoClose: 3000, progress: 0 });
                    setOtpReferenceId(res?.data?.reference_id || '');
                    setOtpSent(true);
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'An error occurred while sending OTP.', { autoClose: 3000, progress: 0 });
            })
            .finally(() => setIsSendingOtp(false));
    };

    const handleSubmitOtp = () => {
        if (!otpValue || otpValue.trim() === '') {
            toast.error('Please enter the OTP', { autoClose: 3000, progress: 0 });
            return;
        }
        if (!otpReferenceId) {
            toast.error('Missing reference ID. Please resend OTP.', { autoClose: 3000, progress: 0 });
            return;
        }
        console.log('DEBUG business_entity_id:', localStorage.getItem('business_entity_id'));
        setIsSubmittingOtp(true);
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            reference_id: otpReferenceId,
            otp: otpValue,
        };
        axios.post('/verify_csi_otp', payload)
            .then((res) => {
                if (res?.data?.status === false) {
                    toast.error(res?.data?.message || 'OTP verification failed', { autoClose: 3000, progress: 0 });
                } else {
                    toast.success(res?.data?.message || 'OTP verified successfully', { autoClose: 3000, progress: 0 });
                    handleCloseAutoDownload();
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'An error occurred while verifying OTP.', { autoClose: 3000, progress: 0 });
            })
            .finally(() => setIsSubmittingOtp(false));
    };

    const handleDownloadCSIFile = () => {
        setIsDownloadingCSI(true);
        const payload = {
            tan: employerDetailFormData.tan,
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            quarter: localStorage.getItem('quarter_26Q'),
        };

        axios.post('/download_csi_file', payload)
            .then((res) => {
                if (res?.data?.status === false) {
                    toast.error(res?.data?.message || 'Failed to download CSI file', { autoClose: 3000, progress: 0 });
                    return;
                }
                const csiFileName = res?.data?.filename
                    || `CSI_${localStorage.getItem('quarter_26Q')}_${localStorage.getItem('financial_year_26Q')}.csi`;
                downloadBase64File('application/octet-stream', res.data.file_binary, csiFileName);
                toast.success(res?.data?.message || 'CSI file downloaded successfully', { autoClose: 3000, progress: 0 });
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'An error occurred while downloading the CSI file.', {
                    autoClose: 3000, progress: 0,
                });
            })
            .finally(() => {
                setIsDownloadingCSI(false);
            });
    };

    const formatCurrency = (value) => {
        if (!value || value == null || value === '') return '₹0';
        return `₹${value.toLocaleString('en-IN')}`;
    };

    const FormDetails = () => {
        const renderFormStep = () => {
            switch (activeStep) {
                case 0:
                    return FormStep0();
                case 1:
                    return FormStep1();
                case 2:
                    return FormStep2();
                default:
                    return FormStep0();
            }
        };

        return (
            <div style={{
                backgroundColor: 'rgb(246, 246, 249)',
                padding: '8px'
            }}>
                <div style={{
                    maxWidth: 'auto',
                    margin: '0 auto',
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '360px 1fr',
                    }}>
                        {/* Step Navigation */}
                        <div style={{
                            backgroundColor: '#f8fafc',
                            padding: '24px',
                            borderRight: '1px solid #e5e7eb'
                        }}>
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: '20px'
                            }}>
                                26Q Filing (form-140) Details
                            </h3>
                            {formSteps.map((step) => (
                                <StepIndicator
                                    key={step.id}
                                    step={step}
                                    isActive={activeStep === step.id}
                                    isCompleted={completedSteps.has(step.id)}
                                    onClick={handleStepClick}
                                />
                            ))}
                        </div>

                        {/* Step Content */}
                        <div style={{ padding: '2%' }}>
                            <div>
                                {renderFormStep()} {/* Use the switch function */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    // const FormDetails = () => {
    //     return (
    //         <div style={{
    //             backgroundColor: 'rgb(246, 246, 249)',
    //             padding: '8px'
    //         }}>
    //             <div style={{
    //                 maxWidth: 'auto',
    //                 margin: '0 auto',
    //                 backgroundColor: '#ffffff',
    //                 borderRadius: '16px',
    //                 boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
    //                 overflow: 'hidden'
    //             }}>
    //                 {/* Header */}

    //                 <div style={{
    //                     display: 'grid',
    //                     gridTemplateColumns: '360px 1fr',

    //                 }}>
    //                     {/* Step Navigation */}
    //                     <div style={{
    //                         backgroundColor: '#f8fafc',
    //                         padding: '24px',
    //                         borderRight: '1px solid #e5e7eb'
    //                     }}>
    //                         <h3 style={{
    //                             fontSize: '18px',
    //                             fontWeight: '600',
    //                             color: '#374151',
    //                             marginBottom: '20px'
    //                         }}>
    //                             Form 26Q Details
    //                         </h3>
    //                         {formSteps.map((step) => (
    //                             <StepIndicator
    //                                 key={step.id}
    //                                 step={step}
    //                                 isActive={activeStep === step.id}
    //                                 isCompleted={completedSteps.has(step.id)}
    //                                 onClick={handleStepClick}
    //                             />
    //                         ))}
    //                     </div>

    //                     {/* Step Content */}
    //                     <div style={{ padding: '2%' }}>
    //                         <>

    //                             <div>
    //                                 {formSteps[activeStep].content()}
    //                             </div>



    //                         </>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // };

    const ChallanTable = () => (
        <div style={{ marginTop: '20px' }}>
            <DataGridPro
                rows={challanData}
                columns={challanColumns}
                getRowId={(row, index) =>
                    `${row.challan_no}-${row.pan}-${row.code}-${row.date_of_payment}-${index}`
                }
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                isRowSelectable={() => false}
                sx={{
                    height: '55vh',
                    marginTop: 2,
                    '& .MuiDataGrid-columnHeaders': {
                        // backgroundColor: '#1976d2',
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        backgroundColor: '#607d8b',
                    },

                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    "& .MuiDataGrid-sortIcon": {
                        opacity: 'inherit !important',
                    },

                    "& .MuiDataGrid-iconButtonContainer": {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        '& .MuiDataGrid-columnHeader': {
                            '& .MuiDataGrid-menuIconButton': {
                                display: 'flex !important',
                                visibility: 'visible !important',
                                opacity: '1 !important',
                            },
                        },
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer'
                    },
                }}
            />
        </div>
    );

    const AnnexureTable = () => (
        <div>
            <DataGridPro
                rows={annexureData}
                columns={annexureColumns}
                getRowId={(row) => row._rowKey}
                pagination
                page={page}
                onPageChange={(newPage) => setPage(newPage)}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                pageSizeOptions={[5, 10, 25, 50]}
                isRowSelectable={() => false}
                filterModel={filterModel}
                onFilterModelChange={(model) => setFilterModel(model)}
                sx={{
                    height: '55vh',
                    marginTop: 2,

                    '& .MuiDataGrid-columnHeaders': {
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,

                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        backgroundColor: '#607d8b',

                            '& .MuiDataGrid-menuIconButton': {
                                display: 'flex !important',
                                visibility: 'visible !important',
                                opacity: '1 !important',
                            },
                        },
                    },

                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },

                    '& .MuiDataGrid-sortIcon': {
                        opacity: 'inherit !important',
                    },

                    '& .MuiDataGrid-iconButtonContainer': {
                        visibility: 'visible',
                    },

                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },

                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },

                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },

                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },

                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },

                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },

                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },

                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },

                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer',
                    },
                }}
            />
        </div>
    );

    return (
        <>
            <Box position="relative" mb={1}>
                <Typography
                    variant="h6"
                    align="center"
                    sx={{
                        fontWeight: 700,
                        letterSpacing: 1,
                        textTransform: 'uppercase',
                    }}
                >
                    26Q Filing (form-140) ({localStorage.getItem('financial_year_26Q')} {localStorage.getItem('quarter_26Q')})
                </Typography>

                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ position: 'absolute', top: 0, right: 0 }}
                >
                    {activeFormStep === 2 && (
                        <Button
                            variant="outlined"
                            color="primary"
                            disabled={!isApplyAllEnabled}
                            onClick={handleApplyAllToFiltered}
                            title={
                                !hasActiveFilter
                                    ? 'Filter the grid first, then change a row\'s Nature of Payment to enable Apply All'
                                    : !pendingApplyValue
                                        ? 'Change a row\'s Nature of Payment to enable Apply All'
                                        : 'Apply the selected value to all filtered matching rows'
                            }
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                            }}
                        >
                            {hasActiveFilter && pendingApplyValue
                                ? `Apply All (${applyAllMatchCount})`
                                : 'Apply All'}
                        </Button>
                    )}

                {activeFormStep !== 0 && (
                    <Button
                        variant="outlined"
                        endIcon={
                                isExporting ? (
                                    <svg
                                        width="16" height="16" viewBox="0 0 16 16"
                                        style={{ animation: "spin 0.9s linear infinite", flexShrink: 0 }}
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="8" cy="8" r="6"
                                            fill="none" stroke="currentColor"
                                            strokeWidth="2" strokeDasharray="28"
                                            strokeDashoffset="10" strokeLinecap="round"
                                        />
                                    </svg>
                                ) : (
                                    <img src={excelIconImage} alt="Excel" style={{ width: 20, height: 20 }} />
                                )
                        }
                        color="success"
                            disabled={isExporting}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                                opacity: isExporting ? 0.85 : 1,
                        }}
                        onClick={handleDownloadReport}
                    >
                            {isExporting ? 'EXPORTING...' : 'Export'}
                    </Button>
                )}
                </Stack>
            </Box>

            {/* Content */}
            <Box sx={{ mt: 2 }}>
                {activeFormStep === 0 && FormDetails()}
                {activeFormStep === 1 && ChallanTable()}
                {activeFormStep === 2 && AnnexureTable()}
            </Box>

            <Stack direction="row" spacing={2} sx={{ mt: 3, justifyContent: 'space-between', alignItems: 'center' }}>
                {activeFormStep !== 0 ? (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleBack}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            borderColor: 'primary.main',
                            color: 'primary.main',
                            fontWeight: 500,
                            minWidth: 90,
                            '&:hover': {
                                borderColor: 'primary.dark',
                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                            },
                        }}
                    >
                        Back
                    </Button>
                ) : (
                    <Box />
                )}

                <Box sx={{ flex: 1 }} />

                {activeFormStep !== steps.length - 1 && activeFormStep !== 0 && (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleNext}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            fontWeight: 500,
                            minWidth: 90,
                            boxShadow: 'none',
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            },
                        }}
                    >
                        Next
                    </Button>
                )}

                {activeFormStep === steps.length - 1 && (
                    <>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleSaveAnnexureSelections}
                            disabled={isSavingSelections || isViewOnly}
                            sx={{
                                textTransform: 'none',
                                px: 2,
                                py: 0.8,
                                fontSize: '0.85rem',
                                borderRadius: '8px',
                                fontWeight: 500,
                                minWidth: 90,
                                boxShadow: 'none',
                                backgroundColor: 'secondary.main',
                                '&:hover': {
                                    backgroundColor: 'secondary.dark',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                },
                                '&:disabled': {
                                    backgroundColor: 'secondary.light',
                                    color: '#fff',
                                },
                            }}
                        >
                            {isSavingSelections ? 'Saving...' : 'Save'}
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleGenerateFUVFile}
                            disabled={isFUVGenerating || isViewOnly || !isAllNatureOfPaymentSelected()}
                            sx={{
                                textTransform: 'none',
                                px: 2,
                                py: 0.8,
                                fontSize: '0.85rem',
                                borderRadius: '8px',
                                fontWeight: 500,
                                minWidth: 90,
                                boxShadow: 'none',
                                backgroundColor: 'primary.main',
                                color: '#fff',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#e0e0e0',
                                    color: 'rgba(0, 0, 0, 0.38)',
                                },
                            }}
                        >
                            {isFUVGenerating ? 'Generating...' : 'Generate FUV File'}
                        </Button>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleFile26Q}
                            disabled={isViewOnly || !isAllNatureOfPaymentSelected()}
                        sx={{
                            textTransform: 'none',
                            px: 2,
                            py: 0.8,
                            fontSize: '0.85rem',
                            borderRadius: '8px',
                            fontWeight: 500,
                            minWidth: 90,
                            boxShadow: 'none',
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            },
                        }}
                    >
                        File 26Q
                    </Button>
                    </>
                )}
            </Stack>

            <Dialog
                open={autoDownloadOpen}
                onClose={handleCloseAutoDownload}
                maxWidth="xs"
                fullWidth
                PaperProps={{ sx: { borderRadius: '10px', overflow: 'hidden' } }}
            >
                <DialogTitle
                    sx={{
                        backgroundColor: '#0d3f66',
                        color: '#ffffff',
                        fontWeight: 700,
                        fontSize: '18px',
                        py: 2,
                        px: 3,
                    }}
                >
                    Auto Download
                    <IconButton
                        onClick={handleCloseAutoDownload}
                        sx={{ position: 'absolute', right: 12, top: 12, color: '#ffffff' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
                    <Box sx={{ mt: 1 }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '6px',
                            fontSize: '12px',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            color: '#4b5563',
                            letterSpacing: '0.3px',
                        }}>
                            Phone Number <span style={{ color: 'red' }}>*</span>
                        </label>
                        <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            placeholder="Enter Phone Number"
                            value={autoDownloadPhone}
                            onChange={(e) => setAutoDownloadPhone(e.target.value)}
                            inputProps={{ maxLength: 10 }}
                            disabled={otpSent}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Box>

                    {otpSent && (
                        <Box sx={{ mt: 3 }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '6px',
                                fontSize: '12px',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                color: '#4b5563',
                                letterSpacing: '0.3px',
                            }}>
                                Enter OTP <span style={{ color: 'red' }}>*</span>
                            </label>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={otpValue}
                                onChange={(e) => setOtpValue(e.target.value)}
                                inputProps={{ maxLength: 6 }}
                                placeholder="Enter OTP"
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                            />
                            <Button
                                variant="text"
                                size="small"
                                onClick={handleSendOtp}
                                disabled={isSendingOtp}
                                sx={{ textTransform: 'none', mt: 1, color: '#0d3f66', fontWeight: 600 }}
                            >
                                Resend OTP
                            </Button>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2.5, borderTop: '1px solid #e5e7eb' }}>
                    {!otpSent ? (
                        <Button
                            variant="contained"
                            onClick={handleSendOtp}
                            disabled={isSendingOtp}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#0d3f66',
                                borderRadius: '8px',
                                px: 3,
                                '&:hover': { backgroundColor: '#0a2f4e' },
                            }}
                        >
                            {isSendingOtp ? 'Sending...' : 'Send OTP'}
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={handleSubmitOtp}
                            disabled={isSubmittingOtp}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#0d3f66',
                                borderRadius: '8px',
                                px: 3,
                                '&:hover': { backgroundColor: '#0a2f4e' },
                            }}
                        >
                            {isSubmittingOtp ? 'Submitting...' : 'Submit'}
                        </Button>
                    )}
                    <Button
                        variant="outlined"
                        onClick={handleCloseAutoDownload}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#0d3f66',
                            borderColor: '#0d3f66',
                            borderRadius: '8px',
                            px: 3,
                            '&:hover': { borderColor: '#0a2f4e', backgroundColor: 'rgba(13,63,102,0.04)' },
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Form26QFiling;